import { FieldsToLookupByMasterAttributeId, getExactFriendlyValue, getExactValue, getTiersByBCBSName, IFlexibleFieldWithAttributes, setExactValue } from "global/Application";
import { IGCDataLight } from "global/Reducer/dataSlice";
import { ArrayToLookup, formatDate, parseDate } from "global/Utility/TSFunctions";
import { bcbs_config_category, bcbs_groupconfigurationsnapshot } from "model/CRM";
import { IAccountExtended, Ibcbs_groupconfigurationsnapshot_extended } from "model/CRM.type";
import { IBenefit, IBooleanValue, IDateValue, IEntityReferenceValue, IGroupConfigurationConfig, IGroupConfigurationData, INumberValue, IPharmacyORE, IPlan, TValue } from "model/FlexibleAttributeModel";
import { IFlexibleFormCategoryDefinition } from "model/FlexibleFormModel";
import {
    $matt_$capital_prime_$bcbs_custompharmacyded_family_cp_id,
    $matt_$capital_prime_$bcbs_custompharmacyded_member_cp_id,
    $matt_$capital_prime_$bcbs_custompharmacyoop_family_cp_id,
    $matt_$capital_prime_$bcbs_custompharmacyoop_member_cp_id,
    $matt_$capital_prime_$bcbs_dedaccumulationperiod_cp_id,
    $matt_$capital_prime_$bcbs_dedaccumulatortype_cp_id,
    $matt_$capital_prime_$bcbs_dedfamilyamount_cp_id,
    $matt_$capital_prime_$bcbs_dedindamount_cp_id,
    $matt_$capital_prime_$bcbs_dedintegrationaccum_cp_id,
    $matt_$capital_prime_$bcbs_dedperiodenddate_cp_id,
    $matt_$capital_prime_$bcbs_dedstartdate_cp_id,
    $matt_$capital_prime_$bcbs_dedtoooop_cp_id,
    $matt_$capital_prime_$bcbs_deductible_cp_id,
    $matt_$capital_prime_$bcbs_diffonsitededaccum_cp_id,
    $matt_$capital_prime_$bcbs_diffonsiteoopaccum_cp_id,
    $matt_$capital_prime_$bcbs_onsitedeductiblefeedoop_cp_id,
    $matt_$capital_prime_$bcbs_onsitedeductibletype_cp_id,
    $matt_$capital_prime_$bcbs_onsiteooptype_cp_id,
    $matt_$capital_prime_$bcbs_oonded_cp_id,
    $matt_$capital_prime_$bcbs_oondedaccumtype_cp_id,
    $matt_$capital_prime_$bcbs_oondedfamilyamount_cp_id,
    $matt_$capital_prime_$bcbs_oondedindamount_cp_id,
    $matt_$capital_prime_$bcbs_oonoopaccumtype_cp_id,
    $matt_$capital_prime_$bcbs_oonoopfamamount_cp_id,
    $matt_$capital_prime_$bcbs_oonoopindamount_cp_id,
    $matt_$capital_prime_$bcbs_oop_cp_id,
    $matt_$capital_prime_$bcbs_oopaccumulationperiod_cp_id,
    $matt_$capital_prime_$bcbs_oopaccumulatortype_cp_id,
    $matt_$capital_prime_$bcbs_oopenddate_cp_id,
    $matt_$capital_prime_$bcbs_oopfamilyamount_cp_id,
    $matt_$capital_prime_$bcbs_oopindamount_cp_id,
    $matt_$capital_prime_$bcbs_oopintegrationaccum_cp_id,
    $matt_$capital_prime_$bcbs_oopstartdate_cp_id,
    $matt_$capital_prime_$bcbs_pbdedaccumulationintegration_cp_id,
    $matt_$capital_prime_$bcbs_pboopaccumulationintegration_cp_id,
    $matt_$florida_prime_$bcbs_custompharmacyded_family_id,
    $matt_$florida_prime_$bcbs_custompharmacyded_member_id,
    $matt_$florida_prime_$bcbs_custompharmacyoop_family_id,
    $matt_$florida_prime_$bcbs_custompharmacyoop_member_id,
    $matt_$florida_prime_$bcbs_dedaccumulationenddate_id,
    $matt_$florida_prime_$bcbs_dedaccumulationstartdate_id,
    $matt_$florida_prime_$bcbs_deductible_id,
    $matt_$florida_prime_$bcbs_deductibleaccumulationbasis_id,
    $matt_$florida_prime_$bcbs_deductibleaccumulationperiod_id,
    $matt_$florida_prime_$bcbs_deductibleamount_family_id,
    $matt_$florida_prime_$bcbs_deductibleamount_individual_id,
    $matt_$florida_prime_$bcbs_deductibleintegrationaccumulation_id,
    $matt_$florida_prime_$bcbs_deductibletooop_id,
    $matt_$florida_prime_$bcbs_diffonsitededaccum_id,
    $matt_$florida_prime_$bcbs_diffonsiteoopaccum_id,
    $matt_$florida_prime_$bcbs_isdedaccumulationperiodnot12mo_id,
    $matt_$florida_prime_$bcbs_isoopperiodnot12mo_id,
    $matt_$florida_prime_$bcbs_onsitedeductiblefeedoop_id,
    $matt_$florida_prime_$bcbs_onsitedeductibletype_id,
    $matt_$florida_prime_$bcbs_onsiteooptype_id,
    $matt_$florida_prime_$bcbs_oopaccumulationbasis_id,
    $matt_$florida_prime_$bcbs_oopaccumulationenddate_id,
    $matt_$florida_prime_$bcbs_oopaccumulationintegration_id,
    $matt_$florida_prime_$bcbs_oopaccumulationperiod_id,
    $matt_$florida_prime_$bcbs_oopaccumulationstartdate_id,
    $matt_$florida_prime_$bcbs_oopamount_family_id,
    $matt_$florida_prime_$bcbs_oopamount_individual_id,
    $matt_$florida_prime_$bcbs_outofpocket_id,
    $matt_$medical_$bcbs_aso_ded_family_mon_tier_id,
    $matt_$medical_$bcbs_aso_ded_mbr_mon_tier_id,
    $matt_$medical_$bcbs_aso_ded_oop_benefit_yr_ded_id,
    $matt_$medical_$bcbs_benefitperiodrunsona_id,
    $matt_$medical_$bcbs_fi_ppo_tfamaggfamouttiernetwork_id,
    $matt_$medical_$bcbs_fi_ppo_tfamaggsingletierofnetwork_id,
    $matt_$medical_$bcbs_initialbenefitperiodrunsfrom_id,
    $matt_$medical_$bcbs_initialbenefitperiodrunsthrough_id,
    $matt_$medical_$bcbs_medicaldeductibletype_id,
    $matt_$medical_$bcbs_ongoingbenefitperiodruns_id,
    $matt_$medical_$bcbs_ongoingbenefitperiodrunsthrough1_id,
    $matt_$medical_$bcbs_oopglobalperfamilytier1_id,
    $matt_$medical_$bcbs_oopglobalpermembermaxtier1_id,
    $matt_$medical_$bcbs_outofpockettype_id,
    $matt_$medical_$bcbs_productsid_id
} from "model/MasterAttributeConstants";
import { blankSnapshot } from "model/snapshotTemplate";
import { IPharmacyContextProps } from "./PharmacyList/PharmacyListContext";


export interface IPrimeData {
    summary: Record<string, string | null> | null;
    primeBenefit: IBenefit | null;
    medicalBenefit: IBenefit | null;
    state: IGCDataLight;
}

/**
 * Extract the pharmacy plan + benefits + group numbers from the group configuration data
 * // Create a snapshot of the current data state
    // Required data includes:
    // - Plan details for the current ORE/pre
    // - Merged medical/pharmacy/prime data with a custom flexible form definition reflecting the injected attributes
    // - Group numbers for plans on both sides
 * @param xJson 
 * @param config 
 * @param pharmacyExtractId 
 * @returns 
 */
export const BuildPrimeData = async (xState: IGCDataLight, pharmacyExtractId: string): Promise<IPrimeData> => {

    const nState: IGCDataLight = {
        ...xState,
        json: blankSnapshot(),
    };

    const ret: IPrimeData = {
        state: nState,
        primeBenefit: null,
        medicalBenefit: null,
        summary: null
    };

    const config = xState.config;
    const xJson = xState.json;
    const nJson = nState.json;

    const pharmacyExtracts = xJson.pharmacyORE?.filter(eachORE => eachORE.id === pharmacyExtractId) ?? [];

    if (pharmacyExtracts.length > 1) {
        throw new Error("Expecting a single pharmacy ORE");
    }

    if (pharmacyExtracts.length < 1) {
        //throw new Error("Expecting a single pharmacy ORE");
        return ret;
    }

    const pharmacyExtract = pharmacyExtracts[0];

    const plans = xJson.plans.filter(eachPlan => eachPlan.id === pharmacyExtractId);

    if (plans.length !== 1) {
        throw new Error("Expecting a single plan");
        // return ret;
    }

    const plan = plans[0];

    nJson.lineOfBusiness = structuredClone(xJson.lineOfBusiness);
    nJson.erisa = structuredClone(xJson.erisa);
    // nJson.fundingType = structuredClone(xJson.fundingType);
    // nJson.bcbs_shortname = structuredClone(xJson.bcbs_shortname);
    // nJson.changeType = structuredClone(xJson.changeType);
    // nJson.deactivated = structuredClone(xJson.deactivated);
    // nJson.status = structuredClone(xJson.status);
    // nJson.operativeDate = structuredClone(xJson.operativeDate);
    // nJson.effectiveDate = structuredClone(xJson.effectiveDate);
    // nJson.dualFunded = structuredClone(xJson.dualFunded);
    // nJson.grandFathered = structuredClone(xJson.grandFathered);
    // nJson.transformers = structuredClone(xJson.transformers);
    // nJson.reconciliation = structuredClone(xJson.reconciliation);

    // New Plan ------------------------------------
    const nPlan = structuredClone(plan);
    nJson.plans.push(nPlan);

    let primeBenefit: IBenefit | null = null as any;

    let floridaPrimeBenefit: IBenefit | null = null as any;
    let capitalPrimeBenefit: IBenefit | null = null as any;

    // as any: due to TS bug, primeBenefit was assumed never

    let medicalBenefit: IBenefit | null = null as any;
    // as any: due to TS bug, primeBenefit was assumed never

    // New Benefits --------------------------------
    const benefitLookup = ArrayToLookup(xJson.benefits);

    plan.benefitRefs.forEach(eachBenefitRef => {

        const benefit = benefitLookup[eachBenefitRef.id];

        const isBCBSRx = benefit.bcbs_config_categoryid === config.cache.map_bcbs_config_category_named.Pharmacy?.bcbs_config_categoryid;

        const isFloridaPrime = benefit.bcbs_config_categoryid === config.cache.map_bcbs_config_category_named["Florida Prime"]?.bcbs_config_categoryid;
        const isCapitalPrime = benefit.bcbs_config_categoryid === config.cache.map_bcbs_config_category_named["Capital Prime"]?.bcbs_config_categoryid;

        const isMedical = benefit.bcbs_config_categoryid === config.cache.map_bcbs_config_category_named.Medical?.bcbs_config_categoryid;

        if (isFloridaPrime || isCapitalPrime) {

            const nBenefit = structuredClone(benefit);
            nJson.benefits.push(nBenefit);

            primeBenefit = nBenefit;

            if (isFloridaPrime)
                floridaPrimeBenefit = nBenefit;

            if (isCapitalPrime)
                capitalPrimeBenefit = nBenefit;
        }

        if (isMedical) {
            const nBenefit = structuredClone(benefit);
            // we don`t need medical, it will be baked into prime
            // nGConfig.benefits.push(nBenefit);
            medicalBenefit = nBenefit;
        }
    });

    if (primeBenefit && medicalBenefit && floridaPrimeBenefit) {
        updateFloridaPrimeBenefitWithMedicalBenefit(ret.state.snapshot, config, medicalBenefit, primeBenefit);
    }

    if (primeBenefit && medicalBenefit && capitalPrimeBenefit) {
        updateCapitalPrimeBenefitWithMedicalBenefit(ret.state.snapshot, config, medicalBenefit, primeBenefit);
    }

    // Group Numbers ----------------------------
    const usedCESNumbers: Record<string, any> = {};
    xJson.groupStructure.groupNumbers.forEach(eachGroupNumber => {
        if (eachGroupNumber.planRef?.id === pharmacyExtractId) {

            const cesNumberId = eachGroupNumber.cesNumberRef?.id;
            if (cesNumberId)
                usedCESNumbers[cesNumberId] = eachGroupNumber;

            nJson.groupStructure.groupNumbers.push(structuredClone(eachGroupNumber));
        }
    });

    // CES Numbers ------------------------------
    xJson.groupStructure.cesNumbers.forEach(eachCESNumber => {
        if (usedCESNumbers[eachCESNumber.id]) {
            nJson.groupStructure.cesNumbers.push(structuredClone(eachCESNumber));
        }
    })

    ret.medicalBenefit = medicalBenefit;
    ret.primeBenefit = primeBenefit;
    ret.state = nState;

    ret.summary = GetPrimeSummary(nState, medicalBenefit, primeBenefit, pharmacyExtract, plan);

    console.log("LoadPharmacyDataOrDefault/pharmacyExtractId", ret, pharmacyExtractId);

    return ret;
}

// 
export const InjectIntoFlexibleFormDef = (
    flexibleFormDefinition: IFlexibleFormCategoryDefinition,
    primeCategory: bcbs_config_category,
    injector?: any
) => {

    const nFlexibleFormDefinition: typeof flexibleFormDefinition = {
        ...flexibleFormDefinition,
        tabs: [],
        attributes: [],
    };

    flexibleFormDefinition.tabs.forEach((xTabDef, tabIndex) => {

        const nTabDef: typeof xTabDef = {
            tab: xTabDef.tab,
            sections: [],
            attributes: [],
        };

        xTabDef.sections.forEach((xSecDef, sectionIndex) => {

            const nSecDef: typeof xSecDef = {
                section: xSecDef.section,
                attributes: [],
                rows: [],
            };

            // xSecDef.attributes.forEach((xAttDef, attributeIndex) => {
            //     const nAttDef = xAttDef;
            //     nSecDef.attributes.push(nAttDef);
            // })
            xSecDef.rows.forEach((xRowDef, rowIndex) => {
                const nRowDef = xRowDef;
                nSecDef.rows.push(nRowDef);

                nSecDef.attributes.push(...nRowDef.attributes);
                nTabDef.attributes.push(...nRowDef.attributes);
            });

            nTabDef.sections.push(nSecDef);
        });

        nFlexibleFormDefinition.tabs.push(nTabDef);
    });

    return nFlexibleFormDefinition;
}

export type TPrimeSummaryKeys =
    "snapshot_bcbs_name" |
    "plan_name" |
    "plan_grandfathered" |
    "snapshot_bcbs_effectivedate" |
    "snapshot_bcbs_fundingtypecodename" |
    "json_lineofbusiness" |
    "json_erisa" |
    "account_accountpartnerplan" |
    "carrier" |
    "drugindicator" |
    "bcbs_ongoingbenefitperiodruns" |
    "bcbs_ongoingbenefitperiodrunsthrough1" |
    "pharmacyshortname" |
    "medicalshortname" |
    "clientnumbers" |
    "newclientnumber" |
    "pharmacyplandesign" |
    "newpharmacyplandesign" |
    "bcbs_coordinatebenefitsonpharmacy"

export type TPrimeSummaryRecord = {
    [key in TPrimeSummaryKeys]: string | null;
};

export const GetPrimeSummary = (
    contextData: IGCDataLight,
    medicalBenefit: IBenefit | null,
    primeBenefit: IBenefit | null,
    pharmacyExtract: IPharmacyORE | null,
    plan: IPlan | null,
): TPrimeSummaryRecord => {

    const { config, json } = contextData;
    const snapshot = contextData.snapshot as Ibcbs_groupconfigurationsnapshot_extended;
    const account = contextData.account as IAccountExtended;
    const parentAccount = account["_parentaccountid_value@OData.Community.Display.V1.FormattedValue"];

    const medicalFieldsLookup = medicalBenefit
        ? FieldsToLookupByMasterAttributeId(config, medicalBenefit.fields)
        : null;

    const medical = {
        // Coordinate Benefits on Pharmacy
        // https://bcbsonline.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=f091d4e1-c24b-ec11-8f8e-000d3a3340f2
        bcbs_coordinatebenefitsonpharmacy: $matt_$medical_$bcbs_ongoingbenefitperiodruns_id,

        // bcbs_ongoingbenefitperiodruns
        // Med - On-Going Benefit Period runs(From):
        // https://bcbsonline.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=4f91d4e1-c24b-ec11-8f8e-000d3a3340f2
        bcbs_ongoingbenefitperiodruns: $matt_$medical_$bcbs_ongoingbenefitperiodruns_id,

        // bcbs_ongoingbenefitperiodrunsthrough1
        // https://bcbsonline.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=5191d4e1-c24b-ec11-8f8e-000d3a3340f2
        // Med - On-Going Benefit Period runs: (Through)
        bcbs_ongoingbenefitperiodrunsthrough1: $matt_$medical_$bcbs_ongoingbenefitperiodrunsthrough1_id,
    }

    const planCESNumbers = plan
        ? getPlanCESNumbers(plan, json)
        : null;

    const record: Partial<TPrimeSummaryRecord> = {};

    record.bcbs_coordinatebenefitsonpharmacy = medicalFieldsLookup
        ? getExactFriendlyValue(
            medicalFieldsLookup,
            medical.bcbs_coordinatebenefitsonpharmacy,
            null,
            null,
            null
        )
        : null;

    record.bcbs_ongoingbenefitperiodruns = medicalFieldsLookup
        ? getExactFriendlyValue(
            medicalFieldsLookup,
            medical.bcbs_ongoingbenefitperiodruns,
            null,
            null,
            null
        )
        : null;


    const bcbs_ongoingbenefitperiodrunsthrough1 = medicalFieldsLookup
        ? getExactFriendlyValue(
            medicalFieldsLookup,
            medical.bcbs_ongoingbenefitperiodrunsthrough1,
            null,
            null,
            null
        )
        : null;

    record.bcbs_ongoingbenefitperiodrunsthrough1 = bcbs_ongoingbenefitperiodrunsthrough1;

    record.snapshot_bcbs_name = snapshot.bcbs_name ?? null
    record.plan_name = plan?.name ?? null;

    record.plan_grandfathered = plan?.grandFathered?.name ?? null;

    record.snapshot_bcbs_effectivedate = formatDate(parseDate(snapshot.bcbs_effectivedate!, 'yyyy-MM-ddThh:mm:ssZ as local'), 'local:MM/dd/yyyy');
    record.snapshot_bcbs_fundingtypecodename = snapshot['bcbs_fundingtypecode@OData.Community.Display.V1.FormattedValue'];


    record.json_lineofbusiness = json.lineOfBusiness?.name ?? null;
    record.json_erisa = json.erisa?.name ?? null;

    record.account_accountpartnerplan = account["_parentaccountid_value@OData.Community.Display.V1.FormattedValue"]

    const getCarrier = (medicalLookup: Record<string, IFlexibleFieldWithAttributes[]>) => {
        // if med.bcbs_productsid contains "PPO" then use "NAJX", if med.bcbs_productsid contains "HMO" then use "NAJXHMO"
        const bcbs_productsid = getExactFriendlyValue(medicalLookup,
            $matt_$medical_$bcbs_productsid_id,
            null,
            null,
            null
        ) ?? ""

        let carrier: string | null = null;
        carrier = /ppo/i.test(bcbs_productsid) ? "NAJX" : carrier;
        carrier = /hmo/i.test(bcbs_productsid) ? "NAJXHMO" : carrier;

        return carrier;
    }

    record.carrier = medicalFieldsLookup
        ? getCarrier(medicalFieldsLookup)
        : null;

    record.drugindicator = "Y";

    record.pharmacyshortname = primeBenefit?.name ?? null;
    record.medicalshortname = medicalBenefit?.name ?? null;

    record.clientnumbers = planCESNumbers && Object.keys(planCESNumbers).length > 0
        ? Object.keys(planCESNumbers).sort().join(", ")
        : null;

    // name: 'Manual Client Number(s)',
    record.newclientnumber = pharmacyExtract?.newClientNumber
        ? pharmacyExtract?.newClientNumber
        : null;

    // name: 'Pharmacy Plan Design',
    record.pharmacyplandesign = pharmacyExtract?.pharmacyPlanDesign
        ? pharmacyExtract?.pharmacyPlanDesign
        : null;

    // name: 'New Pharmacy Plan Design',
    record.newpharmacyplandesign = pharmacyExtract?.newPharmacyPlanDesign
        ? pharmacyExtract?.newPharmacyPlanDesign
        : null;

    return record as TPrimeSummaryRecord;
}

export const getPlanCESNumbers = (plan: IPlan, xJson: IGroupConfigurationData) => {
    const planCESNumbers: Record<string, string | undefined> = {};

    if (plan)
        xJson.groupStructure.groupNumbers.forEach(gn => {
            if (gn.planRef?.id === plan.id)
                if (gn.cesNumberRef?.name)
                    planCESNumbers[gn.cesNumberRef?.name] = gn.cesNumberRef?.name;

        });
    return planCESNumbers;
}

const getMedicalFields = () => {

    // Medical 
    // ---------------------------------------------------------------
    const medical = {
        // Med Deductible Type
        // https://bcbsonline.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=5591d4e1-c24b-ec11-8f8e-000d3a3340f2
        // optionset, not-tiered, not-pcpspecialist
        // Family Aggregate Deductible (Indicator 27)
        // Individual (Indicator 21)
        // Standard Deductible (Indicator 23)
        // True Family Aggregate Deductible (Indicator 22 Embedded)
        bcbs_medicaldeductibletype: $matt_$medical_$bcbs_medicaldeductibletype_id,

        // Out of Pocket Type
        // https://bcbsonline.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=6d91d4e1-c24b-ec11-8f8e-000d3a3340f2
        // optionset, not-tiered, not-pcpspecialist
        // Family Coinsurance (Indicator 22)
        // Individual and Family Coinsurance Based on Member Coverage Status (Indicator 27)
        // Individual and Family Combination Coinsurance (Indicator 24)
        // Individual Coinsurance (Indicator 20)
        bcbs_outofpockettype: $matt_$medical_$bcbs_outofpockettype_id,

        // OOP: Does Deductible Apply to OOP
        // https://bcbsonline.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=7991d4e1-c24b-ec11-8f8e-000d3a3340f2
        // currency, not-tiered, not-pcpspecialist
        bcbs_aso_ded_oop_benefit_yr_ded: $matt_$medical_$bcbs_aso_ded_oop_benefit_yr_ded_id,

        // Global OOP Per Family
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=7191d4e1-c24b-ec11-8f8e-000d3a3340f2
        // currency, tiered, not-pcpspecialist
        bcbs_oopglobalperfamilytier1: $matt_$medical_$bcbs_oopglobalperfamilytier1_id,

        // Standard OOP Per Family
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=7591d4e1-c24b-ec11-8f8e-000d3a3340f2
        // currency, tiered, not-pcpspecialist
        bcbs_aso_ded_family_mon_tier: $matt_$medical_$bcbs_aso_ded_family_mon_tier_id,

        // Global OOP Per Member
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=6f91d4e1-c24b-ec11-8f8e-000d3a3340f2
        // currency, tiered, not-pcpspecialist
        bcbs_oopglobalpermembermaxtier1: $matt_$medical_$bcbs_oopglobalpermembermaxtier1_id,

        // Standard OOP Per Member
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=7391d4e1-c24b-ec11-8f8e-000d3a3340f2
        // currency, tiered, not-pcpspecialist
        bcbs_aso_ded_mbr_mon_tier: $matt_$medical_$bcbs_aso_ded_mbr_mon_tier_id,

        // Per Family Deductibles
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=5991d4e1-c24b-ec11-8f8e-000d3a3340f2
        // Currency, tiered, not-pcpspecialist
        bcbs_fi_ppo_tfamaggfamouttiernetwork: $matt_$medical_$bcbs_fi_ppo_tfamaggfamouttiernetwork_id,

        // Per Member Deductibles
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=5791d4e1-c24b-ec11-8f8e-000d3a3340f2
        // Currency, tiered, not-pcpspecialist
        bcbs_fi_ppo_tfamaggsingletierofnetwork: $matt_$medical_$bcbs_fi_ppo_tfamaggsingletierofnetwork_id,

        // Med - Initial Benefit Period runs: (From)
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=4b91d4e1-c24b-ec11-8f8e-000d3a3340f2
        // Date, not-tiered, not-pcpspecialist
        bcbs_initialbenefitperiodrunsfrom: $matt_$medical_$bcbs_initialbenefitperiodrunsfrom_id,

        // Med - Initial Benefit Period runs: (Through)
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=4d91d4e1-c24b-ec11-8f8e-000d3a3340f2
        // Date, not-tiered, not-pcpspecialist
        bcbs_initialbenefitperiodrunsthrough: $matt_$medical_$bcbs_initialbenefitperiodrunsthrough_id,

        // Med - Benefit Period runs on a
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=4991d4e1-c24b-ec11-8f8e-000d3a3340f2
        // Option Set, not-tiered, not-pcpspecialist
        // name:Calendar Year/value:1/bcbs_config_optionsetitemid:7f1636d7-1f49-ec11-8c60-000d3a3075d0
        // name:Contract Year/value:2/bcbs_config_optionsetitemid:811636d7-1f49-ec11-8c60-000d3a3075d0
        bcbs_benefitperiodrunsona: $matt_$medical_$bcbs_benefitperiodrunsona_id,
    };

    return medical;
}

const getFloridaPrimeMedicalFriendlyFields = () => {

    // Prime
    // -----------------------------------------------------------------------
    const floridaPrime = {

        // Deductible
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=002b677f-6270-ef11-a670-0022482800f2
        // Optionset-IEntityReferenceValue
        // No -> 20
        // No -> 40
        // Yes -> 10
        // Yes -> 30
        bcbs_deductible: $matt_$florida_prime_$bcbs_deductible_id,

        // Out of Pocket
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=3d2c677f-6270-ef11-a670-0022482800f2
        // Optionset-IEntityReferenceValue
        // No -> 20
        // No -> 40
        // Yes -> 10
        // Yes -> 30
        bcbs_outofpocket: $matt_$florida_prime_$bcbs_outofpocket_id,

        // Onsite OOP Accumulations Apply
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=4e9a0c75-488f-ef11-ac21-7c1e52017188
        // optionset-IEntityReferenceValue
        // Medical => 10,
        // Medical Tier 1 => 20,
        // None => 30,
        // Pharmacy => 40,
        bcbs_diffonsiteoopaccum: $matt_$florida_prime_$bcbs_diffonsiteoopaccum_id,

        // Different Onsite Deductible Accumulations Apply
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=78048878-468f-ef11-ac21-7c1e52017188
        // optionset-IEntityReferenceValue
        // Medical => 10,
        // Medical Tier 1 => 20,
        // None => 30,
        // Pharmacy => 40,
        bcbs_diffonsitededaccum: $matt_$florida_prime_$bcbs_diffonsitededaccum_id,

        // Deductible Integration Accumulation
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=022b677f-6270-ef11-a670-0022482800f2
        // optionset
        // Combined Pharmacy and Medical => 20,
        // Pharmacy Only => 10,
        bcbs_deductibleintegrationaccumulation: $matt_$florida_prime_$bcbs_deductibleintegrationaccumulation_id,

        // OOP Accumulation Integration
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=3f2c677f-6270-ef11-a670-0022482800f2
        // !two attributes
        // optionset
        // Combined Pharmacy and Medical => him, value(10)
        // Combined Pharmacy and Medical => 10,
        // Pharmacy Only => 20,
        bcbs_oopaccumulationintegration: $matt_$florida_prime_$bcbs_oopaccumulationintegration_id,
    };

    // Prime Fields < - > Medical Fields
    // -----------------------------------------------------------------------
    const floridaPrimeTarget = {
        // Onsite Deductible Per Family
        // Currency, not-tiered, not-pcpspecialist
        pr_bcbs_custompharmacyded_family: $matt_$florida_prime_$bcbs_custompharmacyded_family_id,

        // Onsite Deductible Per Member
        // Currency, not-tiered, not-pcpspecialist
        pr_bcbs_custompharmacyded_member: $matt_$florida_prime_$bcbs_custompharmacyded_member_id,

        // Onsite OOP Per Family
        // Currency, not-tiered, not-pcpspecialist
        pr_bcbs_custompharmacyoop_family: $matt_$florida_prime_$bcbs_custompharmacyoop_family_id,

        // Onsite OOP Per Member
        // Currency, not-tiered, not-pcpspecialist
        pr_bcbs_custompharmacyoop_member: $matt_$florida_prime_$bcbs_custompharmacyoop_member_id,

        // Onsite Deductible Type
        // Option Set, not-tiered, not-pcpspecialist
        pr_bcbs_onsitedeductibletype: $matt_$florida_prime_$bcbs_onsitedeductibletype_id,

        // Onsite OOP Type
        // Aggregate
        // Embedded
        // Option Set, not-tiered, not-pcpspecialist
        pr_bcbs_onsiteooptype: $matt_$florida_prime_$bcbs_onsiteooptype_id,

        // Onsite Does Deductible Apply to OOP
        // Boolean, not-tiered, not-pcpspecialist
        pr_bcbs_onsitedeductiblefeedoop: $matt_$florida_prime_$bcbs_onsitedeductiblefeedoop_id,

        // Deductible Amount - Family
        // Currency, not-tiered, not-pcpspecialist
        pr_bcbs_deductibleamount_family: $matt_$florida_prime_$bcbs_deductibleamount_family_id,

        // Deductible Amount - Individual
        // Currency, not-tiered, not-pcpspecialist
        pr_bcbs_deductibleamount_individual: $matt_$florida_prime_$bcbs_deductibleamount_individual_id,

        // Deductible Type
        // Option Set, not-tiered, not-pcpspecialist
        pr_bcbs_deductibleaccumulationbasis: $matt_$florida_prime_$bcbs_deductibleaccumulationbasis_id,

        // Deductible Accumulation Period
        // Option Set, not-tiered, not-pcpspecialist
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=0a2b677f-6270-ef11-a670-0022482800f2
        // name:Ben Reset Date/value:20/bcbs_config_optionsetitemid:34e78971-5e70-ef11-a670-002248280da1
        // name:Calendar/value:10/bcbs_config_optionsetitemid:32e78971-5e70-ef11-a670-002248280da1
        pr_bcbs_deductibleaccumulationperiod: $matt_$florida_prime_$bcbs_deductibleaccumulationperiod_id,

        // DED Accumulation not equal to 12 months
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=0e2b677f-6270-ef11-a670-0022482800f2
        // Boolean, not-tiered, not-pcpspecialist
        pr_bcbs_isdedaccumulationperiodnot12mo: $matt_$florida_prime_$bcbs_isdedaccumulationperiodnot12mo_id,

        // DED Accumulation Start Date
        // Date, not-tiered, not-pcpspecialist
        pr_bcbs_dedaccumulationstartdate: $matt_$florida_prime_$bcbs_dedaccumulationstartdate_id,

        // DED Accumulation End Date
        // Date, not-tiered, not-pcpspecialist
        pr_bcbs_dedaccumulationenddate: $matt_$florida_prime_$bcbs_dedaccumulationenddate_id,

        // OOP Amount - Family
        // Currency, not-tiered, not-pcpspecialist
        pr_bcbs_oopamount_family: $matt_$florida_prime_$bcbs_oopamount_family_id,

        // OOP Amount- Individual
        // Currency, not-tiered, not-pcpspecialist
        pr_bcbs_oopamount_individual: $matt_$florida_prime_$bcbs_oopamount_individual_id,

        // OOP Type
        // Option Set, not-tiered, not-pcpspecialist
        // Aggregate
        // Embedded
        pr_bcbs_oopaccumulationbasis: $matt_$florida_prime_$bcbs_oopaccumulationbasis_id,

        // OOP Accumulation Period
        // Option Set, not-tiered, not-pcpspecialist
        // Ben Reset Date/20
        // Calendar/10
        pr_bcbs_oopaccumulationperiod: $matt_$florida_prime_$bcbs_oopaccumulationperiod_id,

        // OOP Accumulation not equal to 12 months
        // Boolean, not-tiered, not-pcpspecialist
        pr_bcbs_isoopperiodnot12mo: $matt_$florida_prime_$bcbs_isoopperiodnot12mo_id,

        // OOP Accumulation Start Date
        // Date, not-tiered, not-pcpspecialist
        pr_bcbs_oopaccumulationstartdate: $matt_$florida_prime_$bcbs_oopaccumulationstartdate_id,

        // OOP Accumulation End Date
        // Date, not-tiered, not-pcpspecialist
        pr_bcbs_oopaccumulationenddate: $matt_$florida_prime_$bcbs_oopaccumulationenddate_id,

        // Deductible to OOP?
        // Boolean, not-tiered, not-pcpspecialist
        pr_bcbs_deductibletooop: $matt_$florida_prime_$bcbs_deductibletooop_id,

    };

    return {
        medical: getMedicalFields(),
        floridaPrime,
        floridaPrimeTarget,
    };
}

function updateFloridaPrimeBenefitWithMedicalBenefit(
    snapshot: bcbs_groupconfigurationsnapshot,
    config: IGroupConfigurationConfig,
    medicalBenefit: IBenefit,
    primeBenefit: IBenefit,
) {

    const fields = getFloridaPrimeMedicalFriendlyFields();

    // const monthDiff = (startDate: Date, endDate: Date): number => {
    //     return endDate.getMonth() - startDate.getMonth() +
    //         (12 * (endDate.getFullYear() - startDate.getFullYear()));
    // };

    const monthDiff2 = (startDateString: string, endDateString: string): number => {

        // 2020-01-01 is converted to 2019-12-31 in PT/ET time zones
        // this assumes the date in local time zone, PT example: 2020-01-01 00:00:00 -08:00:00 GMT
        const asLocalDate = (dateString: string): Date => {
            const [year, month, day] = dateString.split('-').map(Number);

            // Note: Month is 0-indexed in JavaScript (0 = January, 11 = December)
            const localDate = new Date(year, month - 1, day);

            return localDate;
        };

        const isLastDayOfMonth = (date: Date): boolean => {
            const nextDay = new Date(date);
            nextDay.setDate(date.getDate() + 1);
            return nextDay.getDate() === 1;
        };

        const IsFirstDayOfTheMonth = (date: Date): boolean => {
            return date.getDate() === 1;
        };

        const startDate = asLocalDate(startDateString);
        const endDate = asLocalDate(endDateString);

        const startDateIsFirstDayOfTheMonth = IsFirstDayOfTheMonth(startDate);
        const endDateIsLastDayOfMonth = isLastDayOfMonth(endDate);

        let months = ((endDate.getFullYear() - startDate.getFullYear()) * 12)
            + (endDate.getMonth() - startDate.getMonth());

        if (endDateIsLastDayOfMonth && startDateIsFirstDayOfTheMonth)
            ++months;

        return months;

    };


    const medicalFieldsLookup = FieldsToLookupByMasterAttributeId(config, medicalBenefit.fields);
    const floridaPrimeFieldsLookup = FieldsToLookupByMasterAttributeId(config, primeBenefit.fields);

    // Injection/Logic
    // -----------------------------------------------------------------------
    // const val = getExactValue<IEntityReferenceValue>(primeFieldsLookup, primeFields.bcbs_diffonsitededaccum, null, undefined, undefined);
    const prime_bcbs_deductible = getExactFriendlyValue(
        floridaPrimeFieldsLookup,
        fields.floridaPrime.bcbs_deductible,
        null,
        null,
        null
    );

    const prime_bcbs_outofpocket = getExactFriendlyValue(
        floridaPrimeFieldsLookup,
        fields.floridaPrime.bcbs_outofpocket,
        null,
        null,
        null
    );


    const prime_bcbs_diffonsitededaccum = getExactFriendlyValue(
        floridaPrimeFieldsLookup,
        fields.floridaPrime.bcbs_diffonsitededaccum,
        null,
        null,
        null
    );

    const prime_bcbs_diffonsiteoopaccum = getExactFriendlyValue(
        floridaPrimeFieldsLookup,
        fields.floridaPrime.bcbs_diffonsiteoopaccum,
        null,
        null,
        null
    );

    const prime_bcbs_deductibleintegrationaccumulation = getExactFriendlyValue(
        floridaPrimeFieldsLookup,
        fields.floridaPrime.bcbs_deductibleintegrationaccumulation,
        null,
        null,
        null
    );

    const prime_bcbs_oopaccumulationintegration = getExactFriendlyValue(
        floridaPrimeFieldsLookup,
        fields.floridaPrime.bcbs_deductibleintegrationaccumulation,
        null,
        null,
        null
    );

    const medicalTiers = getTiersByBCBSName(medicalBenefit, config);

    // Onsite Deductible Per Family
    // ---------------------------------------------------------------
    // verified
    // logic: if prime.bcbs_diffonsitededaccum = Medical OR Medical Tier 1, use medical.bcbs_fi_ppo_tfamaggfamouttiernetwork
    if (["Medical", "Medical Tier 1"].includes(prime_bcbs_diffonsitededaccum ?? "")) {

        const value = getExactValue<INumberValue>(
            medicalFieldsLookup,
            fields.medical.bcbs_fi_ppo_tfamaggfamouttiernetwork,
            medicalTiers,
            'Tier 1',
            null
        );

        setExactValue(
            config,
            floridaPrimeFieldsLookup,
            fields.floridaPrimeTarget.pr_bcbs_custompharmacyded_family,
            null,
            null,
            null,
            value
        );
    }

    // Onsite Deductible Per Member
    // Per Member Deductibles
    // ---------------------------------------------------------------
    // verified
    // logic : if prime.bcbs_diffonsitededaccum = Medical OR Medical Tier 1, use medical.bcbs_fi_ppo_tfamaggsingletierofnetwork
    if (["Medical", "Medical Tier 1"].includes(prime_bcbs_diffonsitededaccum ?? "")) {

        const value = getExactValue<INumberValue>(
            medicalFieldsLookup,
            fields.medical.bcbs_fi_ppo_tfamaggsingletierofnetwork,
            medicalTiers,
            'Tier 1',
            null
        );

        if (value)
            setExactValue(
                config,
                floridaPrimeFieldsLookup,
                fields.floridaPrimeTarget.pr_bcbs_custompharmacyded_member,
                null,
                null,
                null,
                value
            );
    }

    // Onsite OOP Per Family
    // Onsite Pharmacy OOP Per Family
    // ---------------------------------------------------------------
    // verified
    // logic:
    // if prime.bcbs_diffonsiteoopaccum = Medical OR Medical Tier 1,
    // if medical.bcbs_oopglobalperfamilytier1 has a value, use bcbs_oopglobalperfamilytier1.
    // If not, use medical.bcbs_aso_ded_family_mon_tier
    if (["Medical", "Medical Tier 1"].includes(prime_bcbs_diffonsiteoopaccum ?? "")) {

        const value = getExactValue<INumberValue>(
            medicalFieldsLookup,
            fields.medical.bcbs_oopglobalperfamilytier1,
            medicalTiers,
            'Tier 1',
            null
        );

        if (value) {
            setExactValue(
                config,
                floridaPrimeFieldsLookup,
                fields.floridaPrimeTarget.pr_bcbs_custompharmacyoop_family,
                null,
                null,
                null,
                value
            );
        }
        else {
            const value = getExactValue<INumberValue>(
                medicalFieldsLookup,
                fields.medical.bcbs_aso_ded_family_mon_tier,
                medicalTiers,
                'Tier 1',
                null
            );

            if (value)
                setExactValue(
                    config,
                    floridaPrimeFieldsLookup,
                    fields.floridaPrimeTarget.pr_bcbs_custompharmacyoop_family,
                    null,
                    null,
                    null,
                    value
                );
        }
    }

    // Onsite OOP Per Member
    // Onsite Pharmacy OOP Per Member
    // ---------------------------------------------------------------
    // logic:
    // if prime.bcbs_diffonsiteoopaccum = Medical OR Medical Tier 1,
    // check if medical.bcbs_oopglobalpermembermaxtier1 has a value. If it does use, medical.bcbs_oopglobalpermembermaxtier1.
    // If not, use medical.bcbs_aso_ded_mbr_mon_tier
    if (["Medical", "Medical Tier 1"].includes(prime_bcbs_diffonsiteoopaccum ?? "")) {

        const newValue = getExactValue<INumberValue>(
            medicalFieldsLookup,
            fields.medical.bcbs_oopglobalpermembermaxtier1,
            medicalTiers,
            'Tier 1',
            null
        );

        if (newValue) {
            setExactValue(
                config,
                floridaPrimeFieldsLookup,
                fields.floridaPrimeTarget.pr_bcbs_custompharmacyoop_member,
                null,
                null,
                null,
                newValue
            );
        }
        else {
            const newValue = getExactValue<INumberValue>(
                medicalFieldsLookup,
                fields.medical.bcbs_aso_ded_mbr_mon_tier,
                medicalTiers,
                'Tier 1',
                null
            );

            if (newValue)
                setExactValue(
                    config,
                    floridaPrimeFieldsLookup,
                    fields.floridaPrimeTarget.pr_bcbs_custompharmacyoop_member,
                    null,
                    null,
                    null,
                    newValue
                );
        }
    }

    // Onsite Deductible Type
    // ---------------------------------------------------------------
    // logic:
    // if prime.bcbs_diffonsitededaccum is "Medical" or "Medical Tier 1"
    //     get the value of medical.bcbs_medicaldeductibletype
    //     if the value is "Individual (Indicator 21)" or "True Family Aggregate Deductible (Indicator 22 Embedded)" or "Standard Deductible (Indicator 23)"
    //         set the new value to "Embedded"
    //     else if the value is "Family Aggregate Deductible (Indicator 27)"
    //         set the new value to "Aggregate"
    if (["Medical", "Medical Tier 1"].includes(prime_bcbs_diffonsitededaccum ?? "")) {

        const value = getExactValue<IEntityReferenceValue>(
            medicalFieldsLookup,
            fields.medical.bcbs_medicaldeductibletype,
            medicalTiers,
            null,
            null
        );

        // Values:
        // Family Aggregate Deductible (Indicator 27)
        // Individual (Indicator 21)
        // Standard Deductible (Indicator 23)
        // True Family Aggregate Deductible (Indicator 22 Embedded)
        if (value) {
            let newValue: string | null = null;

            if (
                value.name.includes("Indicator 21") ||
                value.name.includes("Indicator 22") ||
                value.name.includes("Indicator 23")
            )
                newValue = "Embedded";
            else if (value.name.includes("Indicator 27"))
                newValue = "Aggregate";

            if (newValue)
                setExactValue(
                    config,
                    floridaPrimeFieldsLookup,
                    fields.floridaPrimeTarget.pr_bcbs_onsitedeductibletype,
                    null,
                    null,
                    null,
                    newValue,
                );
        }

    }

    // Onsite OOP Type
    // ---------------------------------------------------------------
    // logic:
    // if prime.bcbs_diffonsiteoopaccum = Medical OR Medical Tier 1, check medical.bcbs_outofpockettype, if (oopType.ToLower() == ""individual coinsurance (indicator 20)"" ||
    //    oopType.ToLower() == ""individual and family combination coinsurance (indicator 24)"")
    //    return "Embedded";
    // else if (oopType.ToLower() == ""family coinsurance (indicator 22)"" ||
    //    oopType.ToLower() == ""individual and family coinsurance based on member coverage status (indicator 27)"")
    //    return "Aggregate";
    if (["Medical", "Medical Tier 1"].includes(prime_bcbs_diffonsiteoopaccum ?? "")) {
        const value = getExactValue<IEntityReferenceValue>(
            medicalFieldsLookup,
            fields.medical.bcbs_outofpockettype,
            medicalTiers,
            null,
            null
        );

        // Values:
        // Family Coinsurance (Indicator 22)
        // Individual and Family Coinsurance Based on Member Coverage Status (Indicator 27)
        // Individual and Family Combination Coinsurance (Indicator 24)
        // Individual Coinsurance (Indicator 20)
        if (value) {
            let newValue: string | null = null;

            if (
                value.name.includes("Indicator 20") ||
                value.name.includes("Indicator 24")
            )
                newValue = "Embedded";
            else if (
                value.name.includes("Indicator 22") ||
                value.name.includes("Indicator 27")
            )
                newValue = "Aggregate";


            if (newValue)
                setExactValue(
                    config,
                    floridaPrimeFieldsLookup,
                    fields.floridaPrimeTarget.pr_bcbs_onsiteooptype,
                    null,
                    null,
                    null,
                    newValue
                );
        }
    }


    // Does Deductible Apply to OOP
    // ---------------------------------------------------------------
    // logic:
    // if prime.bcbs_diffonsiteoopaccum = Medical OR Medical Tier 1, check medical.bcbs_aso_ded_oop_benefit_yr_ded
    if (["Medical", "Medical Tier 1"].includes(prime_bcbs_diffonsiteoopaccum ?? "")) {

        const value = getExactValue<IEntityReferenceValue>(
            medicalFieldsLookup,
            fields.medical.bcbs_aso_ded_oop_benefit_yr_ded,
            medicalTiers,
            null,
            null
        );


        if (value)
            setExactValue(
                config,
                floridaPrimeFieldsLookup,
                fields.floridaPrimeTarget.pr_bcbs_onsitedeductiblefeedoop,
                null,
                null,
                null,
                value
            );
    }


    // Deductible Amount - Family
    // ---------------------------------------------------------------
    // verified
    // logic:
    // if prime.bcbs_deductibleintegrationaccumulation = "Combined Pharmacy and Medical", use medical.bcbs_fi_ppo_tfamaggfamouttiernetwork (In Network) value
    if (["Combined Pharmacy and Medical"].includes(prime_bcbs_deductibleintegrationaccumulation ?? "")) {

        const value = getExactValue<INumberValue>(
            medicalFieldsLookup,
            fields.medical.bcbs_fi_ppo_tfamaggfamouttiernetwork,
            medicalTiers,
            'In Network',
            null
        );

        setExactValue(
            config,
            floridaPrimeFieldsLookup,
            fields.floridaPrimeTarget.pr_bcbs_deductibleamount_family,
            null,
            null,
            null,
            value
        );
    }

    // Deductible Amount - Individual
    // ---------------------------------------------------------------
    // logic: if bcbs_deductibleintegrationaccumulation = "Combined Pharmacy and Medical", use medical.bcbs_fi_ppo_tfamaggsingletierofnetwork (In Network)
    if (["Combined Pharmacy and Medical"].includes(prime_bcbs_deductibleintegrationaccumulation ?? "")) {

        const value = getExactValue<INumberValue>(
            medicalFieldsLookup,
            fields.medical.bcbs_fi_ppo_tfamaggsingletierofnetwork,
            medicalTiers,
            'In Network',
            null
        );

        setExactValue(
            config,
            floridaPrimeFieldsLookup,
            fields.floridaPrimeTarget.pr_bcbs_deductibleamount_individual,
            null,
            null,
            null,
            value
        );
    }

    // Deductible Type
    // ---------------------------------------------------------------
    // logic:
    // if (prime.bcbs_deductible) = "Yes" then
    //  if prime.bcbs_deductibleintegrationaccumulation is not "Pharmacy Only"
    //     if medical.bcbs_medicaldeductibletype is "individual (indicator 21)" or "true family aggregate deductible (indicator 22 embedded)" or "standard deductible (indicator 23)"
    //         return "Embedded"
    //     else if medical.bcbs_medicaldeductibletype is "family aggregate deductible (indicator 27)"
    //         return "Aggregate"
    if ((prime_bcbs_deductible ?? "") === "Yes") {
        if ((prime_bcbs_deductibleintegrationaccumulation ?? "") !== "Pharmacy Only") {

            const value = getExactValue<IEntityReferenceValue>(
                medicalFieldsLookup,
                fields.medical.bcbs_medicaldeductibletype,
                medicalTiers,
                null,
                null
            );

            // Values:
            // Family Aggregate Deductible (Indicator 27)
            // Individual (Indicator 21)
            // Standard Deductible (Indicator 23)
            // True Family Aggregate Deductible (Indicator 22 Embedded)
            if (value) {
                let newValue: string | null = null;

                if (
                    value.name.includes("Indicator 21") ||
                    value.name.includes("Indicator 22") ||
                    value.name.includes("Indicator 23")
                )
                    newValue = "Embedded";

                if (value.name.includes("Indicator 27"))
                    newValue = "Aggregate";

                if (newValue)
                    setExactValue(
                        config,
                        floridaPrimeFieldsLookup,
                        fields.floridaPrimeTarget.pr_bcbs_deductibleaccumulationbasis,
                        null,
                        null,
                        null,
                        newValue,
                    );
            }

        }
    }

    // Deductible Accumulation Period
    // ---------------------------------------------------------------
    // logic:
    // if (prime.bcbs_deductible) = "yes" then
    //  if medical.bcbs_benefitperiodrunsona is 'Calendar Year'
    //     set prime.bcbs_deductibleaccumulationperiod to 'Calendar'
    //  else if medical.bcbs_benefitperiodrunsona is 'Contract Year'
    //     set prime.bcbs_deductibleaccumulationperiod to 'Ben Reset Date'
    if ((prime_bcbs_deductible ?? "") === "Yes") {
        const medical_bcbs_benefitperiodrunsona = getExactValue<IEntityReferenceValue>(
            medicalFieldsLookup,
            fields.medical.bcbs_benefitperiodrunsona,
            null,
            null,
            null
        );

        if (medical_bcbs_benefitperiodrunsona?.name === "Calendar Year") {
            setExactValue(
                config,
                floridaPrimeFieldsLookup,
                fields.floridaPrimeTarget.pr_bcbs_deductibleaccumulationperiod,
                null,
                null,
                null,
                "Calendar"
            );
        }

        if (medical_bcbs_benefitperiodrunsona?.name === "Contract Year") {
            setExactValue(
                config,
                floridaPrimeFieldsLookup,
                fields.floridaPrimeTarget.pr_bcbs_deductibleaccumulationperiod,
                null,
                null,
                null,
                "Ben Reset Date"
            );
        }
    }

    // DED Accumulation not equal to 12 months
    // ---------------------------------------------------------------
    // logic:
    // if (prime.bcbs_deductible) = "yes" then
    //  if the snapshot.bcbs_effectivedate matches the medical.bcbs_initialbenefitperiodrunsfrom
    //     if the difference in months between the medical.bcbs_initialbenefitperiodrunsfrom and medical.bcbs_initialbenefitperiodrunsthrough is less than 12
    //         set prime.bcbs_isdedaccumulationperiodnot12mo to 'Yes'
    //     else
    //         set prime.bcbs_isdedaccumulationperiodnot12mo to 'No'
    if ((prime_bcbs_deductible ?? "") === "Yes") {

        const bcbs_initialbenefitperiodrunsfrom = getExactValue<IDateValue>(
            medicalFieldsLookup,
            fields.medical.bcbs_initialbenefitperiodrunsfrom,
            null,
            null,
            null
        );

        const bcbs_initialbenefitperiodrunsthrough = getExactValue<IDateValue>(
            medicalFieldsLookup,
            fields.medical.bcbs_initialbenefitperiodrunsthrough,
            null,
            null,
            null
        );


        const fromDateString = bcbs_initialbenefitperiodrunsfrom?.value
            ? bcbs_initialbenefitperiodrunsfrom.value
            : null;

        const fromDateUTC = bcbs_initialbenefitperiodrunsfrom?.value
            ? new Date(bcbs_initialbenefitperiodrunsfrom.value!)
            : null;

        const throughDateString = bcbs_initialbenefitperiodrunsthrough?.value
            ? bcbs_initialbenefitperiodrunsthrough.value
            : null;

        const throughDateUTC = bcbs_initialbenefitperiodrunsthrough?.value
            ? new Date(bcbs_initialbenefitperiodrunsthrough.value!)
            : null;


        // Check Timezone matching or not match
        const bcbs_effectivedate = snapshot.bcbs_effectivedate
            ? new Date(snapshot.bcbs_effectivedate)
            : null;

        const yesBooleanValue: TValue = {
            type: "bool",
            value: false,
        };

        if (bcbs_effectivedate?.toDateString() === fromDateUTC?.toDateString()) {
            if (fromDateString && throughDateString) {
                const months = monthDiff2(fromDateString, throughDateString);
                yesBooleanValue.value = months != 12;
            }
        }

        setExactValue(
            config,
            floridaPrimeFieldsLookup,
            fields.floridaPrimeTarget.pr_bcbs_isdedaccumulationperiodnot12mo,
            null,
            null,
            null,
            yesBooleanValue
        );

    }

    // DED Accumulation Start Date
    // ---------------------------------------------------------------
    // logic: if (prime.bcbs_deductible) = "yes" then copy
    if ((prime_bcbs_deductible ?? "") === "Yes") {
        const value = getExactValue<IDateValue>(
            medicalFieldsLookup,
            fields.medical.bcbs_initialbenefitperiodrunsfrom,
            null,
            null,
            null
        );

        setExactValue(
            config,
            floridaPrimeFieldsLookup,
            fields.floridaPrimeTarget.pr_bcbs_dedaccumulationstartdate,
            null,
            null,
            null,
            value
        );
    }

    // DED Accumulation End Date
    // ---------------------------------------------------------------
    // logic: 
    // if prime.bcbs_isdedaccumulationperiodnot12mo set to yes then copy
    // *** THE ORDER IS IMPORTANT - DEPENDENCY ***
    // Note: bcbs_isdedaccumulationperiodnot12mo is calculated in this same function first
    const prime_bcbs_isdedaccumulationperiodnot12mo = getExactFriendlyValue(
        floridaPrimeFieldsLookup,
        fields.floridaPrimeTarget.pr_bcbs_isdedaccumulationperiodnot12mo,
        null,
        null,
        null
    );

    if ((prime_bcbs_isdedaccumulationperiodnot12mo ?? "") === "Yes") {
        const value = getExactValue<IDateValue>(
            medicalFieldsLookup,
            fields.medical.bcbs_initialbenefitperiodrunsthrough,
            null,
            null,
            null
        );

        setExactValue(
            config,
            floridaPrimeFieldsLookup,
            fields.floridaPrimeTarget.pr_bcbs_dedaccumulationenddate,
            null,
            null,
            null,
            value
        );
    }

    // OOP Amount - Family
    // ---------------------------------------------------------------
    // logic:
    // if prime.bcbs_oopaccumulationintegration is not "Pharmacy Only"
    //    if medical.bcbs_oopglobalperfamilytier1,in-network has a value
    //        set prime.bcbs_oopamount_family to medical.bcbs_oopglobalperfamilytier1
    //    else
    //        set prime.bcbs_oopamount_family to medical.bcbs_aso_ded_family_mon_tier
    if (prime_bcbs_oopaccumulationintegration !== "Pharmacy Only") {

        const bcbs_oopglobalperfamilytier1 = getExactValue<INumberValue>(
            medicalFieldsLookup,
            fields.medical.bcbs_oopglobalperfamilytier1,
            medicalTiers,
            'In Network',
            null
        );

        if (bcbs_oopglobalperfamilytier1?.value) {
            setExactValue(
                config,
                floridaPrimeFieldsLookup,
                fields.floridaPrimeTarget.pr_bcbs_oopamount_family,
                null,
                null,
                null,
                bcbs_oopglobalperfamilytier1
            );
        } else {

            const bcbs_aso_ded_family_mon_tier = getExactValue<INumberValue>(
                medicalFieldsLookup,
                fields.medical.bcbs_aso_ded_family_mon_tier,
                medicalTiers,
                'In Network',
                null
            );

            if (bcbs_aso_ded_family_mon_tier?.value) {
                setExactValue(
                    config,
                    floridaPrimeFieldsLookup,
                    fields.floridaPrimeTarget.pr_bcbs_oopamount_family,
                    null,
                    null,
                    null,
                    bcbs_aso_ded_family_mon_tier
                );
            }

        }
    }

    // OOP Amount- Individual
    // ---------------------------------------------------------------
    // Logic:
    // if prime.bcbs_oopaccumulationintegration is not "Pharmacy Only":
    //     Check if medical.bcbs_oopglobalpermembermaxtier1 has a value.
    //     if it does, use  medical.bcbs_oopglobalpermembermaxtier1, in-network.
    //     if not, use  medical.bcbs_aso_ded_mbr_mon_tier, in-network.
    if (prime_bcbs_oopaccumulationintegration !== "Pharmacy Only") {

        const bcbs_oopglobalpermembermaxtier1 = getExactValue<INumberValue>(
            medicalFieldsLookup,
            fields.medical.bcbs_oopglobalpermembermaxtier1,
            medicalTiers,
            'In Network',
            null
        );

        if (bcbs_oopglobalpermembermaxtier1?.value) {
            setExactValue(
                config,
                floridaPrimeFieldsLookup,
                fields.floridaPrimeTarget.pr_bcbs_oopamount_individual,
                null,
                null,
                null,
                bcbs_oopglobalpermembermaxtier1
            );
        } else {

            const bcbs_aso_ded_mbr_mon_tier = getExactValue<INumberValue>(
                medicalFieldsLookup,
                fields.medical.bcbs_aso_ded_mbr_mon_tier,
                medicalTiers,
                'In Network',
                null
            );


            if (bcbs_aso_ded_mbr_mon_tier?.value) {
                setExactValue(
                    config,
                    floridaPrimeFieldsLookup,
                    fields.floridaPrimeTarget.pr_bcbs_oopamount_individual,
                    null,
                    null,
                    null,
                    bcbs_aso_ded_mbr_mon_tier
                );
            }

        }
    }

    // OOP Type
    // ---------------------------------------------------------------
    // Question? is oopType bcbs_outofpockettype? renambe to medical.bcbs_outofpockettype
    // logic:
    // if prime.bcbs_outofpocket is set to Yes then
    //  if prime.bcbs_oopaccumulationintegration is not "Pharmacy Only":
    //    if oopType is "individual coinsurance (indicator 20)" or "individual and family combination coinsurance (indicator 24)":
    //        return "Embedded"
    //    else if oopType is "family coinsurance (indicator 22)" or "individual and family coinsurance based on member coverage status (indicator 27)":
    //        return "Aggregate"
    if ((prime_bcbs_outofpocket ?? "") === "Yes") {
        if (prime_bcbs_oopaccumulationintegration !== "Pharmacy Only") {

            // Family Coinsurance (Indicator 22)
            // Individual and Family Coinsurance Based on Member Coverage Status (Indicator 27)
            // Individual and Family Combination Coinsurance (Indicator 24)
            // Individual Coinsurance (Indicator 20)
            const value = getExactValue<IEntityReferenceValue>(
                medicalFieldsLookup,
                fields.medical.bcbs_outofpockettype,
                medicalTiers,
                null,
                null
            );

            if (value) {
                let newValue: string | null = null;

                if (
                    value.name.includes("Indicator 20") ||
                    value.name.includes("Indicator 24")
                ) {
                    newValue = "Embedded";
                } else if (
                    value.name.includes("Indicator 22") ||
                    value.name.includes("Indicator 27")
                ) {
                    newValue = "Aggregated / Non-Embedded";
                }

                if (newValue)
                    setExactValue(
                        config,
                        floridaPrimeFieldsLookup,
                        fields.floridaPrimeTarget.pr_bcbs_oopaccumulationbasis,
                        null,
                        null,
                        null,
                        newValue
                    );
            }
        }
    }


    // OOP Accumulation Period
    // ---------------------------------------------------------------
    // logic:
    // if prime.bcbs_outofpocket is set to Yes then
    //  if medical.bcbs_benefitperiodrunsona is 'Calendar Year'
    //     set prime.bcbs_oopaccumulationperiod to 'Calendar Year'
    //  else if medical.bcbs_benefitperiodrunsona is 'Contract Year'
    //     set prime.bcbs_oopaccumulationperiod to 'Ben Reset Date'
    if ((prime_bcbs_outofpocket ?? "") === "Yes") {
        // name:Calendar Year/value:1/bcbs_config_optionsetitemid:7f1636d7-1f49-ec11-8c60-000d3a3075d0
        // name:Contract Year/value:2/bcbs_config_optionsetitemid:811636d7-1f49-ec11-8c60-000d3a3075d0
        const medical_bcbs_benefitperiodrunsona = getExactValue<IEntityReferenceValue>(
            medicalFieldsLookup,
            fields.medical.bcbs_benefitperiodrunsona,
            null,
            null,
            null
        );

        if (medical_bcbs_benefitperiodrunsona?.name === "Calendar Year") {
            setExactValue(
                config,
                floridaPrimeFieldsLookup,
                fields.floridaPrimeTarget.pr_bcbs_oopaccumulationperiod,
                null,
                null,
                null,
                "Calendar"
            );
        }

        if (medical_bcbs_benefitperiodrunsona?.name === "Contract Year") {
            setExactValue(
                config,
                floridaPrimeFieldsLookup,
                fields.floridaPrimeTarget.pr_bcbs_oopaccumulationperiod,
                null,
                null,
                null,
                "Ben Reset Date"
            );
        }
    }

    // OOP Accumulation not equal to 12 months
    // ---------------------------------------------------------------
    // logic:
    // if prime.bcbs_outofpocket is set to Yes then
    //  if the snapshot.bcbs_effectivedate matches the medical.bcbs_initialbenefitperiodrunsfrom
    //     if the difference in months between the medical.bcbs_initialbenefitperiodrunsfrom and medical.bcbs_initialbenefitperiodrunsthrough is less than 12
    //         set prime.bcbs_isoopperiodnot12mo to 'Yes'
    //     else
    //         set prime.bcbs_isoopperiodnot12mo to 'No'
    if ((prime_bcbs_outofpocket ?? "") === "Yes") {
        const bcbs_initialbenefitperiodrunsfrom = getExactValue<IDateValue>(
            medicalFieldsLookup,
            fields.medical.bcbs_initialbenefitperiodrunsfrom,
            null,
            null,
            null
        );

        const bcbs_initialbenefitperiodrunsthrough = getExactValue<IDateValue>(
            medicalFieldsLookup,
            fields.medical.bcbs_initialbenefitperiodrunsthrough,
            null,
            null,
            null
        );

        const fromDateString = bcbs_initialbenefitperiodrunsfrom?.value
            ? bcbs_initialbenefitperiodrunsfrom.value
            : null;

        const fromDateUTC = bcbs_initialbenefitperiodrunsfrom?.value
            ? new Date(bcbs_initialbenefitperiodrunsfrom.value!)
            : null;

        const throughDateString = bcbs_initialbenefitperiodrunsthrough?.value
            ? bcbs_initialbenefitperiodrunsthrough.value
            : null;

        const throughDateUTC = bcbs_initialbenefitperiodrunsthrough?.value
            ? new Date(bcbs_initialbenefitperiodrunsthrough.value!)
            : null;

        // Check Timezone matching or not match
        const bcbs_effectivedate = snapshot.bcbs_effectivedate
            ? new Date(snapshot.bcbs_effectivedate)
            : null;

        const yesBooleanValue: TValue = {
            type: "bool",
            value: false,
        };

        if (bcbs_effectivedate?.toDateString() === fromDateUTC?.toDateString()) {
            if (fromDateString && throughDateString) {

                const months = monthDiff2(fromDateString, throughDateString);
                yesBooleanValue.value = months != 12;
            }
        }

        setExactValue(
            config,
            floridaPrimeFieldsLookup,
            fields.floridaPrimeTarget.pr_bcbs_isoopperiodnot12mo,
            null,
            null,
            null,
            yesBooleanValue
        );
    }

    // OOP Accumulation Start Date
    // ---------------------------------------------------------------
    // logic: 
    // if prime.bcbs_outofpocket is set to Yes then copy
    if ((prime_bcbs_outofpocket ?? "") === "Yes") {

        const value = getExactValue<IDateValue>(
            medicalFieldsLookup,
            fields.medical.bcbs_initialbenefitperiodrunsfrom,
            null,
            null,
            null
        );

        setExactValue(
            config,
            floridaPrimeFieldsLookup,
            fields.floridaPrimeTarget.pr_bcbs_oopaccumulationstartdate,
            null,
            null,
            null,
            value
        );
    }

    // OOP Accumulation End Date
    // ---------------------------------------------------------------
    // logic: 
    // if prime.bcbs_isoopperiodnot12mo set to yes then copy
    // *** THE ORDER IS IMPORTANT - DEPENDENCY ***
    // Note: bcbs_isoopperiodnot12mo is calculated in this same function first
    const prime_bcbs_isoopperiodnot12mo = getExactFriendlyValue(
        floridaPrimeFieldsLookup,
        fields.floridaPrimeTarget.pr_bcbs_isoopperiodnot12mo,
        null,
        null,
        null
    );

    if ((prime_bcbs_isoopperiodnot12mo ?? "") === "Yes") {
        const value = getExactValue<IDateValue>(
            medicalFieldsLookup,
            fields.medical.bcbs_initialbenefitperiodrunsthrough,
            null,
            null,
            null
        );

        setExactValue(
            config,
            floridaPrimeFieldsLookup,
            fields.floridaPrimeTarget.pr_bcbs_oopaccumulationenddate,
            null,
            null,
            null,
            value
        );
    }

    // Deductible to OOP?
    // ---------------------------------------------------------------
    // logic:
    //    if prime.bcbs_oopaccumulationintegration is not "Pharmacy Only"
    //        Get the value of medical.bcbs_oopglobalpermembermaxtier1
    //        if the value is not empty
    //            Return "Yes"
    //        Get the value of medical.bcbs_aso_ded_oop_benefit_yr_ded
    //        if the value is "yes"
    //            Return "Yes"
    if ((prime_bcbs_deductible ?? "") === "Yes") {
        if ((prime_bcbs_oopaccumulationintegration ?? "") !== "Pharmacy Only") {

            let setYes = false;

            const bcbs_oopglobalpermembermaxtier1 = getExactValue<INumberValue>(
                medicalFieldsLookup,
                fields.medical.bcbs_oopglobalpermembermaxtier1,
                medicalTiers,
                'In Network',
                null
            );

            const bcbs_aso_ded_oop_benefit_yr_ded = getExactValue<INumberValue>(
                medicalFieldsLookup,
                fields.medical.bcbs_aso_ded_oop_benefit_yr_ded,
                null,
                null,
                null
            );

            if (bcbs_oopglobalpermembermaxtier1?.value) {
                setYes = true;
            } else if (bcbs_aso_ded_oop_benefit_yr_ded?.value) {
                setYes = true;
            }

            if (setYes) {

                const yesBooleanValue: TValue = {
                    type: "bool",
                    value: true,
                };

                setExactValue(
                    config,
                    floridaPrimeFieldsLookup,
                    fields.floridaPrimeTarget.pr_bcbs_deductibletooop,
                    null,
                    null,
                    null,
                    yesBooleanValue
                );
            }

        }
    }
    else {
        const noBooleanValue: TValue = {
            type: "bool",
            value: false,
        };

        setExactValue(
            config,
            floridaPrimeFieldsLookup,
            fields.floridaPrimeTarget.pr_bcbs_deductibletooop,
            null,
            null,
            null,
            noBooleanValue
        );
    }

}

const getCapitalPrimeMedicalFriendlyFields = () => {

    // Prime
    // bcbs_dedaccumulationperiod_cp
    // bcbs_dedstartdate_cp
    // bcbs_dedperiodenddate_cp
    // bcbs_dedaccumulatortype_cp
    // bcbs_dedfamilyamount_cp
    // bcbs_dedindamount_cp
    // bcbs_dedtoooop_cp
    // bcbs_custompharmacyded_family_cp
    // bcbs_custompharmacyded_member_cp
    // bcbs_onsitedeductibletype_cp
    // bcbs_onsitedeductiblefeedoop_cp
    // bcbs_custompharmacyoop_family_cp
    // bcbs_custompharmacyoop_member_cp
    // bcbs_onsiteooptype_cp
    // bcbs_oondedaccumtype_cp
    // bcbs_oondedindamount_cp
    // bcbs_oondedfamilyamount_cp
    // bcbs_oonoopaccumtype_cp
    // bcbs_oonoopindamount_cp
    // bcbs_oonoopfamamount_cp
    // bcbs_oopaccumulatortype_cp
    // bcbs_oopaccumulationperiod_cp
    // bcbs_oopstartdate_cp
    // bcbs_oopenddate_cp
    // bcbs_oopindamount_cp
    // bcbs_oopfamilyamount_cp

    // -----------------------------------------------------------------------
    const capitalPrime = {

        // Deductible
        // Boolean
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=9badae9b-6d75-f111-ab0f-6045bdd96b88
        bcbs_deductible_cp: $matt_$capital_prime_$bcbs_deductible_cp_id,

        // Deductible Integration Accumulation
        // Option Set: Pharmacy Only(10), Combined Pharmacy and Medical(20)
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=9dadae9b-6d75-f111-ab0f-6045bdd96b88
        bcbs_dedintegrationaccum_cp: $matt_$capital_prime_$bcbs_dedintegrationaccum_cp_id,

        // Deductible Accumulator Type
        // Option Set: Embedded(10), Aggregated / Non-Embedded(20)
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=45d60bf5-f3a6-f111-b8de-00224820a2a5
        bcbs_dedaccumulatortype_cp: $matt_$capital_prime_$bcbs_dedaccumulatortype_cp_id,

        // Deductible Family Amount
        // Currency
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=6a258ae9-eea6-f111-b8de-00224820a2a5
        bcbs_dedfamilyamount_cp: $matt_$capital_prime_$bcbs_dedfamilyamount_cp_id,

        // Deductible Individual Amount
        // Currency
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=97836749-eea6-f111-b8de-00224820a2a5
        bcbs_dedindamount_cp: $matt_$capital_prime_$bcbs_dedindamount_cp_id,

        // Is there an OON Deductible?
        // Boolean
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=9f11f121-5479-f111-ab0f-002248260c25
        bcbs_oonded_cp: $matt_$capital_prime_$bcbs_oonded_cp_id,

        // OON Deductible Accumulation Integration
        // Option Set: Pharmacy Only(10), Combined Pharmacy and Medical(20)
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=a311f121-5479-f111-ab0f-002248260c25
        bcbs_pbdedaccumulationintegration_cp: $matt_$capital_prime_$bcbs_pbdedaccumulationintegration_cp_id,

        // OON Deductible Accumulator Type
        // Option Set: Embedded(10), Aggregated / Non-Embedded(20)
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=13d634a4-ada7-f111-b8de-00224820a2a5
        bcbs_oondedaccumtype_cp: $matt_$capital_prime_$bcbs_oondedaccumtype_cp_id,

        // OON Deductible Individual Amount
        // Currency
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=ee2260b2-6ca8-f111-b8de-00224820a2a5
        bcbs_oondedindamount_cp: $matt_$capital_prime_$bcbs_oondedindamount_cp_id,

        // OON Deductible Family Amount
        // Currency
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=32b5fbb4-6da8-f111-b8de-00224820a2a5
        bcbs_oondedfamilyamount_cp: $matt_$capital_prime_$bcbs_oondedfamilyamount_cp_id,

        // OON Out of Pocket Accumulation Integration
        // Option Set: Pharmacy Only(10), Combined Pharmacy and Medical(20)
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=b111f121-5479-f111-ab0f-002248260c25
        bcbs_pboopaccumulationintegration_cp: $matt_$capital_prime_$bcbs_pboopaccumulationintegration_cp_id,

        // OON Out of Pocket Accumulator Type
        // Option Set: Embedded(10), Aggregated / Non-Embedded(20)
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=1bf01a1c-6ea8-f111-b8de-00224820a2a5
        bcbs_oonoopaccumtype_cp: $matt_$capital_prime_$bcbs_oonoopaccumtype_cp_id,

        // OON Out of Pocket Individual Amount
        // Currency
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=bcb6d364-6ea8-f111-b8de-00224820a2a5
        bcbs_oonoopindamount_cp: $matt_$capital_prime_$bcbs_oonoopindamount_cp_id,

        // OON Out of Pocket Family Amount
        // Currency
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=d097ec9c-6ea8-f111-b8de-00224820a2a5
        bcbs_oonoopfamamount_cp: $matt_$capital_prime_$bcbs_oonoopfamamount_cp_id,

        // Out of Pocket Integration Accumulation
        // Option Set: Pharmacy Only(10), Combined Pharmacy and Medical(20)
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=b9adae9b-6d75-f111-ab0f-6045bdd96b88
        bcbs_oopintegrationaccum_cp: $matt_$capital_prime_$bcbs_oopintegrationaccum_cp_id,

        // Out of Pocket Accumulator Type
        // Option Set: Embedded(10), Aggregated / Non-Embedded(20)
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=5f35679d-f5a6-f111-b8de-00224820a2a5
        bcbs_oopaccumulatortype_cp: $matt_$capital_prime_$bcbs_oopaccumulatortype_cp_id,

        // Out of Pocket
        // Boolean
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=b7adae9b-6d75-f111-ab0f-6045bdd96b88
        bcbs_oop_cp: $matt_$capital_prime_$bcbs_oop_cp_id,

        // Out of Pocket Individual Amount
        // Currency
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=41437f7e-f0a6-f111-b8de-00224820a2a5
        bcbs_oopindamount_cp: $matt_$capital_prime_$bcbs_oopindamount_cp_id,

        // Out of Pocket Family Amount
        // Currency
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=4de60d43-f1a6-f111-b8de-00224820a2a5
        bcbs_oopfamilyamount_cp: $matt_$capital_prime_$bcbs_oopfamilyamount_cp_id,

        // Onsite Deductible Accumulations Apply
        // Option Set: Medical(10), Medical Tier 1(20), None(30), Pharmacy(40)
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=a276e0c6-e5b1-f111-aaad-7ced8dd8496b
        bcbs_diffonsitededaccum_cp: $matt_$capital_prime_$bcbs_diffonsitededaccum_cp_id,

        // Onsite Deductible Per Family
        // Currency
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=a476e0c6-e5b1-f111-aaad-7ced8dd8496b
        bcbs_custompharmacyded_family_cp: $matt_$capital_prime_$bcbs_custompharmacyded_family_cp_id,

        // Onsite Deductible Per Member
        // Currency
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=a676e0c6-e5b1-f111-aaad-7ced8dd8496b
        bcbs_custompharmacyded_member_cp: $matt_$capital_prime_$bcbs_custompharmacyded_member_cp_id,

        // Onsite OOP Accumulations Apply
        // Option Set: Medical(10), Medical Tier 1(20), None(30), Pharmacy(40)
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=ac76e0c6-e5b1-f111-aaad-7ced8dd8496b
        bcbs_diffonsiteoopaccum_cp: $matt_$capital_prime_$bcbs_diffonsiteoopaccum_cp_id,

        // Onsite Does Deductible Apply to OOP
        // Boolean
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=aa76e0c6-e5b1-f111-aaad-7ced8dd8496b
        bcbs_onsitedeductiblefeedoop_cp: $matt_$capital_prime_$bcbs_onsitedeductiblefeedoop_cp_id,

        // Onsite OOP Per Family
        // Currency
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=b076e0c6-e5b1-f111-aaad-7ced8dd8496b
        bcbs_custompharmacyoop_family_cp: $matt_$capital_prime_$bcbs_custompharmacyoop_family_cp_id,

        // Onsite OOP Per Member
        // Currency
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=b276e0c6-e5b1-f111-aaad-7ced8dd8496b
        bcbs_custompharmacyoop_member_cp: $matt_$capital_prime_$bcbs_custompharmacyoop_member_cp_id,

        // Onsite Deductible Type
        // Option Set: Embedded(10), Aggregate(20)
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=a876e0c6-e5b1-f111-aaad-7ced8dd8496b
        bcbs_onsitedeductibletype_cp: $matt_$capital_prime_$bcbs_onsitedeductibletype_cp_id,

        // Onsite OOP Type
        // Option Set: Embedded(10), Aggregate(20)
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=b476e0c6-e5b1-f111-aaad-7ced8dd8496b
        bcbs_onsiteooptype_cp: $matt_$capital_prime_$bcbs_onsiteooptype_cp_id,

        // Does Deductible apply to Out of Pocket?
        // Boolean
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=3fefeda9-f6a6-f111-b8de-00224820a2a5
        bcbs_dedtoooop_cp: $matt_$capital_prime_$bcbs_dedtoooop_cp_id,

    };

    // Prime Fields < - > Medical Fields
    // -----------------------------------------------------------------------
    const capitalPrimeTarget = {
        // Deductible Accumulation Period
        // Option Set: Calendar(10), Ben Reset Date(20), Other(30)
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=abadae9b-6d75-f111-ab0f-6045bdd96b88
        bcbs_dedaccumulationperiod_cp: $matt_$capital_prime_$bcbs_dedaccumulationperiod_cp_id,

        // Deductible Accumulation Period Start Date (mm/dd/yyyy)
        // Date
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=c1d8e934-80b7-f111-aaac-70a8a5950881
        bcbs_dedstartdate_cp: $matt_$capital_prime_$bcbs_dedstartdate_cp_id,

        // Deductible Accumulation Period End Date (mm/dd/yyyy)
        // Date
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=19325daf-80b7-f111-aaac-70a8a5950881
        bcbs_dedperiodenddate_cp: $matt_$capital_prime_$bcbs_dedperiodenddate_cp_id,

        // Deductible Accumulator Type
        // Option Set: Embedded(10), Aggregated / Non-Embedded(20)
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=45d60bf5-f3a6-f111-b8de-00224820a2a5
        bcbs_dedaccumulatortype_cp: $matt_$capital_prime_$bcbs_dedaccumulatortype_cp_id,

        // Deductible Family Amount
        // Currency
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=6a258ae9-eea6-f111-b8de-00224820a2a5
        bcbs_dedfamilyamount_cp: $matt_$capital_prime_$bcbs_dedfamilyamount_cp_id,

        // Deductible Individual Amount
        // Currency
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=97836749-eea6-f111-b8de-00224820a2a5
        bcbs_dedindamount_cp: $matt_$capital_prime_$bcbs_dedindamount_cp_id,

        // Does Deductible apply to Out of Pocket?
        // Boolean
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=3fefeda9-f6a6-f111-b8de-00224820a2a5
        bcbs_dedtoooop_cp: $matt_$capital_prime_$bcbs_dedtoooop_cp_id,

        // Onsite Deductible Per Family
        // Currency
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=a476e0c6-e5b1-f111-aaad-7ced8dd8496b
        bcbs_custompharmacyded_family_cp: $matt_$capital_prime_$bcbs_custompharmacyded_family_cp_id,

        // Onsite Deductible Per Member
        // Currency
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=a676e0c6-e5b1-f111-aaad-7ced8dd8496b
        bcbs_custompharmacyded_member_cp: $matt_$capital_prime_$bcbs_custompharmacyded_member_cp_id,

        // Onsite Deductible Type
        // Option Set: Embedded(10), Aggregate(20)
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=a876e0c6-e5b1-f111-aaad-7ced8dd8496b
        bcbs_onsitedeductibletype_cp: $matt_$capital_prime_$bcbs_onsitedeductibletype_cp_id,

        // Onsite Does Deductible Apply to OOP
        // Boolean
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=aa76e0c6-e5b1-f111-aaad-7ced8dd8496b
        bcbs_onsitedeductiblefeedoop_cp: $matt_$capital_prime_$bcbs_onsitedeductiblefeedoop_cp_id,

        // Onsite OOP Per Family
        // Currency
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=b076e0c6-e5b1-f111-aaad-7ced8dd8496b
        bcbs_custompharmacyoop_family_cp: $matt_$capital_prime_$bcbs_custompharmacyoop_family_cp_id,

        // Onsite OOP Per Member
        // Currency
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=b276e0c6-e5b1-f111-aaad-7ced8dd8496b
        bcbs_custompharmacyoop_member_cp: $matt_$capital_prime_$bcbs_custompharmacyoop_member_cp_id,

        // Onsite OOP Type
        // Option Set: Embedded(10), Aggregate(20)
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=b476e0c6-e5b1-f111-aaad-7ced8dd8496b
        bcbs_onsiteooptype_cp: $matt_$capital_prime_$bcbs_onsiteooptype_cp_id,

        // OON Deductible Accumulator Type
        // Option Set: Embedded(10), Aggregated / Non-Embedded(20)
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=13d634a4-ada7-f111-b8de-00224820a2a5
        bcbs_oondedaccumtype_cp: $matt_$capital_prime_$bcbs_oondedaccumtype_cp_id,

        // OON Deductible Individual Amount
        // Currency
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=ee2260b2-6ca8-f111-b8de-00224820a2a5
        bcbs_oondedindamount_cp: $matt_$capital_prime_$bcbs_oondedindamount_cp_id,

        // OON Deductible Family Amount
        // Currency
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=32b5fbb4-6da8-f111-b8de-00224820a2a5
        bcbs_oondedfamilyamount_cp: $matt_$capital_prime_$bcbs_oondedfamilyamount_cp_id,

        // OON Out of Pocket Accumulator Type
        // Option Set: Embedded(10), Aggregated / Non-Embedded(20)
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=1bf01a1c-6ea8-f111-b8de-00224820a2a5
        bcbs_oonoopaccumtype_cp: $matt_$capital_prime_$bcbs_oonoopaccumtype_cp_id,

        // OON Out of Pocket Individual Amount
        // Currency
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=bcb6d364-6ea8-f111-b8de-00224820a2a5
        bcbs_oonoopindamount_cp: $matt_$capital_prime_$bcbs_oonoopindamount_cp_id,

        // OON Out of Pocket Family Amount
        // Currency
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=d097ec9c-6ea8-f111-b8de-00224820a2a5
        bcbs_oonoopfamamount_cp: $matt_$capital_prime_$bcbs_oonoopfamamount_cp_id,

        // Out of Pocket Accumulator Type
        // Option Set: Embedded(10), Aggregated / Non-Embedded(20)
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=5f35679d-f5a6-f111-b8de-00224820a2a5
        bcbs_oopaccumulatortype_cp: $matt_$capital_prime_$bcbs_oopaccumulatortype_cp_id,

        // Out of Pocket Accumulation Period
        // Option Set: Calendar(10), Ben Reset Date(20), Other(30)
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=6028f1c2-81b7-f111-aaac-70a8a5950881
        bcbs_oopaccumulationperiod_cp: $matt_$capital_prime_$bcbs_oopaccumulationperiod_cp_id,

        // Out of Pocket Accumulation Period Start Date (mm/dd/yyyy)
        // Date
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=70da652c-82b7-f111-aaac-70a8a5950881
        bcbs_oopstartdate_cp: $matt_$capital_prime_$bcbs_oopstartdate_cp_id,

        // Out of Pocket Accumulation Period End Date (mm/dd/yyyy)
        // Date
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=5dcd717b-82b7-f111-aaac-70a8a5950881
        bcbs_oopenddate_cp: $matt_$capital_prime_$bcbs_oopenddate_cp_id,

        // Out of Pocket Individual Amount
        // Currency
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=41437f7e-f0a6-f111-b8de-00224820a2a5
        bcbs_oopindamount_cp: $matt_$capital_prime_$bcbs_oopindamount_cp_id,

        // Out of Pocket Family Amount
        // Currency
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?etn=bcbs_config_masterattribute&pagetype=entityrecord&id=4de60d43-f1a6-f111-b8de-00224820a2a5
        bcbs_oopfamilyamount_cp: $matt_$capital_prime_$bcbs_oopfamilyamount_cp_id,

    };

    return {
        medical: getMedicalFields(),
        capitalPrime,
        capitalPrimeTarget,
    }
}

function updateCapitalPrimeBenefitWithMedicalBenefit(
    snapshot: bcbs_groupconfigurationsnapshot,
    config: IGroupConfigurationConfig,
    medicalBenefit: IBenefit,
    primeBenefit: IBenefit,
) {

    const fields = getCapitalPrimeMedicalFriendlyFields();

    // const monthDiff = (startDate: Date, endDate: Date): number => {
    //     return endDate.getMonth() - startDate.getMonth() +
    //         (12 * (endDate.getFullYear() - startDate.getFullYear()));
    // };

    const monthDiff2 = (startDateString: string, endDateString: string): number => {

        // 2020-01-01 is converted to 2019-12-31 in PT/ET time zones
        // this assumes the date in local time zone, PT example: 2020-01-01 00:00:00 -08:00:00 GMT
        const asLocalDate = (dateString: string): Date => {
            const [year, month, day] = dateString.split('-').map(Number);

            // Note: Month is 0-indexed in JavaScript (0 = January, 11 = December)
            const localDate = new Date(year, month - 1, day);

            return localDate;
        };

        const isLastDayOfMonth = (date: Date): boolean => {
            const nextDay = new Date(date);
            nextDay.setDate(date.getDate() + 1);
            return nextDay.getDate() === 1;
        };

        const IsFirstDayOfTheMonth = (date: Date): boolean => {
            return date.getDate() === 1;
        };

        const startDate = asLocalDate(startDateString);
        const endDate = asLocalDate(endDateString);

        const startDateIsFirstDayOfTheMonth = IsFirstDayOfTheMonth(startDate);
        const endDateIsLastDayOfMonth = isLastDayOfMonth(endDate);

        let months = ((endDate.getFullYear() - startDate.getFullYear()) * 12)
            + (endDate.getMonth() - startDate.getMonth());

        if (endDateIsLastDayOfMonth && startDateIsFirstDayOfTheMonth)
            ++months;

        return months;

    };

    const mLookup = FieldsToLookupByMasterAttributeId(config, medicalBenefit.fields);

    const cpLookup = FieldsToLookupByMasterAttributeId(config, primeBenefit.fields);

    // Injection/Logic
    // -----------------------------------------------------------------------
    // const val = getExactValue<IEntityReferenceValue>(primeFieldsLookup, primeFields.bcbs_diffonsitededaccum, null, undefined, undefined);
    const bcbs_deductible_cp = getExactFriendlyValue(
        cpLookup,
        fields.capitalPrime.bcbs_deductible_cp,
        null,
        null,
        null
    );

    const bcbs_dedintegrationaccum_cp = getExactFriendlyValue(
        cpLookup,
        fields.capitalPrime.bcbs_dedintegrationaccum_cp,
        null,
        null,
        null
    );

    const bcbs_oonded_cp = getExactFriendlyValue(
        cpLookup,
        fields.capitalPrime.bcbs_oonded_cp,
        null,
        null,
        null
    );

    const bcbs_pbdedaccumulationintegration_cp = getExactFriendlyValue(
        cpLookup,
        fields.capitalPrime.bcbs_pbdedaccumulationintegration_cp,
        null,
        null,
        null
    );

    const bcbs_oopintegrationaccum_cp = getExactFriendlyValue(
        cpLookup,
        fields.capitalPrime.bcbs_oopintegrationaccum_cp,
        null,
        null,
        null
    );


    const medical_bcbs_initialbenefitperiodrunsthrough = getExactValue<IDateValue>(
        mLookup,
        fields.medical.bcbs_initialbenefitperiodrunsthrough,
        null,
        null,
        null
    );

    const bcbs_onsitedeductiblefeedoop_cp = getExactFriendlyValue(
        cpLookup,
        fields.capitalPrime.bcbs_onsitedeductiblefeedoop_cp,
        null,
        null,
        null
    );

    const bcbs_dedaccumulatortype_cp = getExactFriendlyValue(
        cpLookup,
        fields.capitalPrime.bcbs_dedaccumulatortype_cp,
        null,
        null,
        null
    );

    const bcbs_oondedaccumtype_cp = getExactFriendlyValue(
        cpLookup,
        fields.capitalPrime.bcbs_oondedaccumtype_cp,
        null,
        null,
        null
    );

    const bcbs_onsitedeductibletype_cp = getExactFriendlyValue(
        cpLookup,
        fields.capitalPrime.bcbs_onsitedeductibletype_cp,
        null,
        null,
        null
    );

    const bcbs_oop_cp = getExactFriendlyValue(
        cpLookup,
        fields.capitalPrime.bcbs_oop_cp,
        null,
        null,
        null
    );

    const bcbs_oopaccumulatortype_cp = getExactFriendlyValue(
        cpLookup,
        fields.capitalPrime.bcbs_oopaccumulatortype_cp,
        null,
        null,
        null
    );

    const bcbs_pboopaccumulationintegration_cp = getExactFriendlyValue(
        cpLookup,
        fields.capitalPrime.bcbs_pboopaccumulationintegration_cp,
        null,
        null,
        null
    );

    const bcbs_oonoopaccumtype_cp = getExactFriendlyValue(
        cpLookup,
        fields.capitalPrime.bcbs_oonoopaccumtype_cp,
        null,
        null,
        null
    );

    const bcbs_diffonsitededaccum_cp = getExactFriendlyValue(
        cpLookup,
        fields.capitalPrime.bcbs_diffonsitededaccum_cp,
        null,
        null,
        null
    );

    const bcbs_diffonsiteoopaccum_cp = getExactFriendlyValue(
        cpLookup,
        fields.capitalPrime.bcbs_diffonsiteoopaccum_cp,
        null,
        null,
        null
    );

    const bcbs_onsiteooptype_cp = getExactFriendlyValue(
        cpLookup,
        fields.capitalPrime.bcbs_onsiteooptype_cp,
        null,
        null,
        null
    );


    const medicalTiers = getTiersByBCBSName(medicalBenefit, config);

    // 1) Deductible Accumulation Period
    // Explaination: When the Capital Prime deductible is Yes, read the medical benefit period.
    // Map Calendar Year to Calendar and Contract Year to Ben Reset Date.
    // ---
    // ---------------------------------------------------------------
    // "if (capitalprime.bcbs_deductible_cp) = ""yes"" then
    //  if medical.bcbs_benefitperiodrunsona is 'Calendar Year'
    //     set FIELD TBD to 'Calendar'
    //  else if medical.bcbs_benefitperiodrunsona is 'Contract Year'
    //     set FIELD TBD to 'Ben Reset Date'"
    if ((bcbs_deductible_cp ?? "") === "Yes") {

        const medical_bcbs_benefitperiodrunsona = getExactValue<IEntityReferenceValue>(
            mLookup,
            fields.medical.bcbs_benefitperiodrunsona,
            null,
            null,
            null
        );

        if (medical_bcbs_benefitperiodrunsona?.name === "Calendar Year") {
            setExactValue(
                config,
                cpLookup,
                fields.capitalPrimeTarget.bcbs_dedaccumulationperiod_cp,
                null,
                null,
                null,
                "Calendar"
            );
        }

        if (medical_bcbs_benefitperiodrunsona?.name === "Contract Year") {
            setExactValue(
                config,
                cpLookup,
                fields.capitalPrimeTarget.bcbs_dedaccumulationperiod_cp,
                null,
                null,
                null,
                "Ben Reset Date"
            );
        }
    }

    // 2) Deductible Accumulation Period Start Date (mm/dd/yyyy)
    // Explaination: When the Capital Prime deductible is Yes, copy the medical initial benefit
    // period start date value to the Capital Prime deductible start date; write null if missing.
    // ---
    // if (capitalprime.bcbs_deductible_cp) = "yes": use medical.bcbs_initialbenefitperiodrunsfrom
    // ---------------------------------------------------------------
    if ((bcbs_deductible_cp ?? "") === "Yes") {

        const medical_bcbs_initialbenefitperiodrunsfrom = getExactValue<IDateValue>(
            mLookup,
            fields.medical.bcbs_initialbenefitperiodrunsfrom,
            null,
            null,
            null
        );

        setExactValue(
            config,
            cpLookup,
            fields.capitalPrimeTarget.bcbs_dedstartdate_cp,
            null,
            null,
            null,
            medical_bcbs_initialbenefitperiodrunsfrom?.value ?? null
        );
    }

    // 3) Deductible Accumulation Period End Date (mm/dd/yyyy)
    // Explaination: When the Capital Prime deductible is Yes, copy the previously-read medical
    // initial benefit period through date value to the Capital Prime deductible end date.
    // Write null if missing.
    // ---
    // if (capitalprime.bcbs_deductible_cp) = "yes": use medicalbcbs_initialbenefitperiodrunsthrough
    // ---------------------------------------------------------------
    if ((bcbs_deductible_cp ?? "") === "Yes") {



        setExactValue(
            config,
            cpLookup,
            fields.capitalPrimeTarget.bcbs_dedperiodenddate_cp,
            null,
            null,
            null,
            medical_bcbs_initialbenefitperiodrunsthrough?.value ?? null
        );
    }

    // 4) Deductible Accumulator Type
    // Explaination: When the deductible is Yes, map recognized medical deductible types to
    // Embedded or Aggregated / Non-Embedded unless integration is Pharmacy Only; then copy the
    // current Capital Prime type. Unknown or missing types are not written.
    // ---
    // if (capitalprime.bcbs_deductible_cp) = ""Yes"" then
    //  if capitalprime.bcbs_dedintegrationaccum_cp is not ""Pharmacy Only""
    //     if medical.bcbs_medicaldeductibletype is ""individual (indicator 21)"" or ""true family aggregate deductible (indicator 22 embedded)"" or ""standard deductible (indicator 23)""
    //         use ""Embedded""
    //     else if medical.bcbs_medicaldeductibletype is ""family aggregate deductible (indicator 27)""
    //         use ""Aggregate""
    // if capitalprime.bcbs_dedintegrationaccum_cp = ""Pharmacy Only"" THEN capitalprime.bcbs_dedaccumulatortype_cp
    // ---------------------------------------------------------------
    if ((bcbs_deductible_cp ?? "") === "Yes") {

        let newValue_bcbs_dedaccumulatortype_cp: string | null = null;
        const value = getExactValue<IEntityReferenceValue>(
            mLookup,
            fields.medical.bcbs_medicaldeductibletype,
            medicalTiers,
            null,
            null
        );

        if ((bcbs_dedintegrationaccum_cp ?? "") !== "Pharmacy Only") {

            if (value) {

                if (value.name.includes("Indicator 21") ||
                    value.name.includes("Indicator 22") ||
                    value.name.includes("Indicator 23")
                ) {
                    newValue_bcbs_dedaccumulatortype_cp = "Embedded";
                } else if (value.name.includes("Indicator 27")) {
                    newValue_bcbs_dedaccumulatortype_cp = "Aggregated / Non-Embedded";
                }

                if (newValue_bcbs_dedaccumulatortype_cp)
                    setExactValue(
                        config,
                        cpLookup,
                        fields.capitalPrimeTarget.bcbs_dedaccumulatortype_cp,
                        null,
                        null,
                        null,
                        newValue_bcbs_dedaccumulatortype_cp
                    );
            }
        }

        else if ((bcbs_dedintegrationaccum_cp ?? "") === "Pharmacy Only") {
            newValue_bcbs_dedaccumulatortype_cp = bcbs_dedaccumulatortype_cp;

            if (newValue_bcbs_dedaccumulatortype_cp) {
                setExactValue(
                    config,
                    cpLookup,
                    fields.capitalPrimeTarget.bcbs_dedaccumulatortype_cp,
                    null,
                    null,
                    null,
                    newValue_bcbs_dedaccumulatortype_cp
                );
            }
        }

    }


    // 5) Deductible Amount - Family
    // Explaination: Combined Pharmacy and Medical copies the medical family deductible for In
    // Network only when its numeric value is truthy. Pharmacy Only re-writes the current Capital
    // Prime family amount when its numeric value is truthy; other integration values do nothing.
    // ---
    // if capitalprime.bcbs_dedintegrationaccum_cp = "Combined Pharmacy and Medical", use medical.bcbs_fi_ppo_tfamaggfamouttiernetwork(In Network) value, else capitalprime.bcbs_dedfamilyamount_cp
    // ---------------------------------------------------------------
    if (bcbs_dedintegrationaccum_cp === "Combined Pharmacy and Medical") {
        // Use medical.bcbs_fi_ppo_tfamaggfamouttiernetwork(In Network) value

        // QA is this in network????

        const value = getExactValue<INumberValue>(
            mLookup,
            fields.medical.bcbs_fi_ppo_tfamaggfamouttiernetwork,
            medicalTiers,
            'In Network',
            null
        );

        if (value?.value) {
            setExactValue(
                config,
                cpLookup,
                fields.capitalPrimeTarget.bcbs_dedfamilyamount_cp,
                null,
                null,
                null,
                value
            );
        }

    } else if (bcbs_dedintegrationaccum_cp === "Pharmacy Only") {
        const value = getExactValue<INumberValue>(
            cpLookup,
            fields.capitalPrime.bcbs_dedfamilyamount_cp,
            null,
            null,
            null
        );

        if (value?.value) {
            setExactValue(
                config,
                cpLookup,
                fields.capitalPrimeTarget.bcbs_dedfamilyamount_cp,
                null,
                null,
                null,
                value
            );
        }
    }


    // 6) Deductible Amount - Individual
    // Explaination: Combined Pharmacy and Medical copies the medical individual deductible for In
    // Network only when its numeric value is truthy. Pharmacy Only re-writes the current Capital
    // Prime individual amount when its numeric value is truthy; other integration values do nothing.
    // ---
    // if capitalprime.bcbs_dedintegrationaccum_cp = "Combined Pharmacy and Medical", use medical.bcbs_fi_ppo_tfamaggsingletierofnetwork (In Network),
    // else use capitalprime.bcbs_dedindamount_cp
    // ---------------------------------------------------------------
    if (bcbs_dedintegrationaccum_cp === "Combined Pharmacy and Medical") {
        // Use medical.bcbs_fi_ppo_tfamaggsingletierofnetwork (In Network) value

        const value = getExactValue<INumberValue>(
            mLookup,
            fields.medical.bcbs_fi_ppo_tfamaggsingletierofnetwork,
            medicalTiers,
            'In Network',
            null
        );

        if (value?.value) {
            setExactValue(
                config,
                cpLookup,
                fields.capitalPrimeTarget.bcbs_dedindamount_cp,
                null,
                null,
                null,
                value
            );
        }

    } else if (bcbs_dedintegrationaccum_cp === "Pharmacy Only") {
        const value = getExactValue<INumberValue>(
            cpLookup,
            fields.capitalPrime.bcbs_dedindamount_cp,
            null,
            null,
            null
        );

        if (value?.value) {
            setExactValue(
                config,
                cpLookup,
                fields.capitalPrimeTarget.bcbs_dedindamount_cp,
                null,
                null,
                null,
                value
            );
        }
    }


    // 7) Does Deductible apply to Out of Pocket?
    // Explaination: Only when OOP is Yes, read the medical boolean for Combined Pharmacy and
    // Medical or the current Capital Prime boolean for Pharmacy Only. Write only when the
    // retrieved boolean is true.
    // ---
    // "IF capitalprime.bcbs_dedintegrationaccum_cp != Pharmacy Only, var oopGlobalPerMemberMax = GetFieldValue(medAttrByLogicalName, medFields, ""bcbs_oopglobalpermembermaxtier1"", tier);
    // if (!string.IsNullOrEmpty(oopGlobalPerMemberMax))
    //     return ""Yes"";
    // var asoDedOOPBenefitYrDed = GetFieldValue(medAttrByLogicalName, medFields, ""bcbs_aso_ded_oop_benefit_yr_ded"");
    // if (asoDedOOPBenefitYrDed?.ToLower() == ""yes"")
    //     return ""Yes"";"
    // ---------------------------------------------------------------
    if (bcbs_dedintegrationaccum_cp === "Combined Pharmacy and Medical" && (bcbs_oop_cp ?? "") === "Yes") {

        const value = getExactValue<IBooleanValue>(
            mLookup,
            fields.medical.bcbs_aso_ded_oop_benefit_yr_ded,
            null,
            null,
            null
        );

        if (value?.value) {
            setExactValue(
                config,
                cpLookup,
                fields.capitalPrimeTarget.bcbs_dedtoooop_cp,
                null,
                null,
                null,
                value
            );
        }

    }
    else if (bcbs_dedintegrationaccum_cp === "Pharmacy Only" && (bcbs_oop_cp ?? "") === "Yes") {
        const value = getExactValue<IBooleanValue>(
            cpLookup,
            fields.capitalPrime.bcbs_dedtoooop_cp,
            null,
            null,
            null
        );

        if (value?.value) {
            setExactValue(
                config,
                cpLookup,
                fields.capitalPrimeTarget.bcbs_dedtoooop_cp,
                null,
                null,
                null,
                value
            );
        }
    }

    // 8) OON Deductible Accumulator Type
    // Explaination: When an OON deductible exists, map recognized medical deductible types to
    // Embedded or Aggregated / Non-Embedded unless integration is Pharmacy Only; then copy the
    // current Capital Prime OON type. Unknown or missing types are not written.
    // ---
    // "if (capitalprkime.bcbs_oonded_cp) = ""Yes"" then
    //  if capitalprime.bcbs_pbdedaccumulationintegration_cp is not ""Pharmacy Only""
    //     if medical.bcbs_medicaldeductibletype is ""individual (indicator 21)"" or ""true family aggregate deductible (indicator 22 embedded)"" or ""standard deductible (indicator 23)""
    //         use ""Embedded""
    //     else if medical.bcbs_medicaldeductibletype is ""family aggregate deductible (indicator 27)""
    //         use ""Aggregate""   
    // if capitalprime.bcbs_pbdedaccumulationintegration_cp = ""Pharmacy Only"" THEN capitalprime.bcbs_oondedaccumtype_cp"
    // ---------------------------------------------------------------
    if (bcbs_oonded_cp === "Yes") {
        if (bcbs_pbdedaccumulationintegration_cp !== "Pharmacy Only") {

            let newValue_bcbs_oondedaccumtype_cp: string | null = null;
            const value = getExactValue<IEntityReferenceValue>(
                mLookup,
                fields.medical.bcbs_medicaldeductibletype,
                medicalTiers,
                null,
                null
            );
            if (value) {
                if (
                    value.name.includes("Indicator 21") ||
                    value.name.includes("Indicator 22") ||
                    value.name.includes("Indicator 23")
                ) {
                    newValue_bcbs_oondedaccumtype_cp = "Embedded";
                } else if (value.name.includes("Indicator 27")) {
                    newValue_bcbs_oondedaccumtype_cp = "Aggregated / Non-Embedded";
                }

                if (newValue_bcbs_oondedaccumtype_cp) {
                    setExactValue(
                        config,
                        cpLookup,
                        fields.capitalPrimeTarget.bcbs_oondedaccumtype_cp,
                        null,
                        null,
                        null,
                        newValue_bcbs_oondedaccumtype_cp
                    );
                }
            }

        } else if (bcbs_pbdedaccumulationintegration_cp === "Pharmacy Only") {
            let newValue_bcbs_oondedaccumtype_cp = bcbs_oondedaccumtype_cp;

            if (newValue_bcbs_oondedaccumtype_cp) {
                setExactValue(
                    config,
                    cpLookup,
                    fields.capitalPrimeTarget.bcbs_oondedaccumtype_cp,
                    null,
                    null,
                    null,
                    newValue_bcbs_oondedaccumtype_cp
                );
            }

        }
    }

    // 9) OON Deductible Individual Amount
    // Explaination: Combined Pharmacy and Medical copies the medical individual deductible for
    // Out of Network when a value object exists. Pharmacy Only re-writes the current Capital
    // Prime OON individual amount only when its numeric value is truthy.
    // ---
    // bcbs_oondedindamount_cp
    // if capitalprime.bcbs_pbdedaccumulationintegration_cp = "Combined Pharmacy and Medical", use medical.bcbs_fi_ppo_tfamaggsingletierofnetwork (Out of Network), else use capitalprime.bcbs_oondedindamount_cp
    // ---------------------------------------------------------------
    if (bcbs_pbdedaccumulationintegration_cp === "Combined Pharmacy and Medical") {

        const value = getExactValue<INumberValue>(
            mLookup,
            fields.medical.bcbs_fi_ppo_tfamaggsingletierofnetwork,
            medicalTiers,
            'Out of Network',
            null
        );

        if (value)
            setExactValue(
                config,
                cpLookup,
                fields.capitalPrimeTarget.bcbs_oondedindamount_cp,
                null,
                null,
                null,
                value
            );
    }
    else if (bcbs_pbdedaccumulationintegration_cp === "Pharmacy Only") {
        const value = getExactValue<INumberValue>(
            cpLookup,
            fields.capitalPrime.bcbs_oondedindamount_cp,
            null,
            null,
            null
        );

        if (value?.value) {
            setExactValue(
                config,
                cpLookup,
                fields.capitalPrimeTarget.bcbs_oondedindamount_cp,
                null,
                null,
                null,
                value
            );
        }

    }


    // 10) OON Deductible Family Amount
    // Explaination: Combined Pharmacy and Medical copies the medical family deductible for Out
    // of Network when a value object exists. Pharmacy Only re-writes the current Capital Prime
    // OON family amount only when its numeric value is truthy.
    // ---
    // bcbs_oondedfamilyamount_cp
    // if capitalprime.bcbs_pbdedaccumulationintegration_cp = "Combined Pharmacy and Medical", use medical.bcbs_fi_ppo_tfamaggfamouttiernetwork (Out of Network), else use capitalprime.bcbs_oondedfamilyamount_cp
    // Florida doesn't use this
    // ---------------------------------------------------------------
    if (bcbs_pbdedaccumulationintegration_cp === "Combined Pharmacy and Medical") {

        const value = getExactValue<INumberValue>(
            mLookup,
            fields.medical.bcbs_fi_ppo_tfamaggfamouttiernetwork,
            medicalTiers,
            'Out of Network',
            null
        );

        if (value)
            setExactValue(
                config,
                cpLookup,
                fields.capitalPrimeTarget.bcbs_oondedfamilyamount_cp,
                null,
                null,
                null,
                value
            );
    }
    else if (bcbs_pbdedaccumulationintegration_cp === "Pharmacy Only") {
        const value = getExactValue<INumberValue>(
            cpLookup,
            fields.capitalPrime.bcbs_oondedfamilyamount_cp,
            null,
            null,
            null
        );

        if (value?.value) {
            setExactValue(
                config,
                cpLookup,
                fields.capitalPrimeTarget.bcbs_oondedfamilyamount_cp,
                null,
                null,
                null,
                value
            );
        }

    }

    // 11) OON Out of Pocket Accumulator Type
    // Explaination: Combined Pharmacy and Medical maps recognized medical OOP types to Embedded
    // or Aggregate; Pharmacy Only copies the current Capital Prime OON OOP type. This block does
    // not check whether OON OOP is enabled.
    // ---
    // if capitalprime.bcbs_pboopaccumulationintegration_cp != Pharmacy Only, if (medical.bcbs_outofpockettype.ToLower() == ""individual coinsurance (indicator 20)"" ||
    //     oopType.ToLower() == ""individual and family combination coinsurance (indicator 24)"")
    //     return ""Embedded"";
    // else if (oopType.ToLower() == ""family coinsurance (indicator 22)"" ||
    //     oopType.ToLower() == ""individual and family coinsurance based on member coverage status (indicator 27)"")
    //     return ""Aggregate""; IF capitalprime.bcbs_pboopaccumulationintegration_cp = Pharmacy Only, capitalprime.bcbs_oonoopaccumtype_cp
    // ---------------------------------------------------------------
    if (bcbs_pboopaccumulationintegration_cp === "Combined Pharmacy and Medical") {

        // Family Coinsurance (Indicator 22)
        // Individual and Family Coinsurance Based on Member Coverage Status (Indicator 27)
        // Individual and Family Combination Coinsurance (Indicator 24)
        // Individual Coinsurance (Indicator 20)
        const value = getExactValue<IEntityReferenceValue>(
            mLookup,
            fields.medical.bcbs_outofpockettype,
            medicalTiers,
            null,
            null
        );

        if (value) {
            let newValue: string | null = null;

            if (
                value.name.includes("Indicator 20") ||
                value.name.includes("Indicator 24")
            ) {
                newValue = "Embedded";
            } else if (
                value.name.includes("Indicator 22") ||
                value.name.includes("Indicator 27")
            ) {
                newValue = "Aggregate";
            }

            if (newValue)
                setExactValue(
                    config,
                    cpLookup,
                    fields.capitalPrimeTarget.bcbs_oonoopaccumtype_cp,
                    null,
                    null,
                    null,
                    newValue
                );
        }
    }
    else if (bcbs_pboopaccumulationintegration_cp === "Pharmacy Only") {
        let newValue_bcbs_oonoopaccumtype_cp = bcbs_oonoopaccumtype_cp;

        if (newValue_bcbs_oonoopaccumtype_cp) {
            setExactValue(
                config,
                cpLookup,
                fields.capitalPrimeTarget.bcbs_oonoopaccumtype_cp,
                null,
                null,
                null,
                newValue_bcbs_oonoopaccumtype_cp
            );
        }
    }

    // 12) OON Out of Pocket Individual Amount
    // Explaination: Pharmacy Only copies the current Capital Prime OON individual amount when
    // its numeric value is truthy. Combined Pharmacy and Medical writes the medical global
    // amount for Out of Network, then the standard amount if present, so it overwrites global.
    // ---
    // IF capitalprime.bcbs_pboopaccumulationintegration_cp != Pharmacy Only, (check if bcbs_oopglobalpermembermaxtier1 has a value. If it does use, bcbs_oopglobalpermembermaxtier1. If not, pull from bcbs_aso_ded_mbr_mon_tier) ELSE IF capitalprime.bcbs_pboopaccumulationintegration_cp = Pharmacy Only, capitalprime.bcbs_oonoopindamount_cp
    // ---------------------------------------------------------------
    if (bcbs_pboopaccumulationintegration_cp === "Pharmacy Only") {
        const value = getExactValue<INumberValue>(
            cpLookup,
            fields.capitalPrime.bcbs_oonoopindamount_cp,
            null,
            null,
            null
        );

        if (value?.value) {
            setExactValue(
                config,
                cpLookup,
                fields.capitalPrimeTarget.bcbs_oonoopindamount_cp,
                null,
                null,
                null,
                value
            );
        }
    }
    else if (bcbs_pboopaccumulationintegration_cp === "Combined Pharmacy and Medical") {
        const goopValue = getExactValue<INumberValue>(
            mLookup,
            fields.medical.bcbs_oopglobalpermembermaxtier1,
            medicalTiers,
            'Out of Network',
            null
        );

        const soopValue = getExactValue<INumberValue>(
            mLookup,
            fields.medical.bcbs_aso_ded_mbr_mon_tier,
            medicalTiers,
            'Out of Network',
            null
        );

        if (goopValue)
            setExactValue(
                config,
                cpLookup,
                fields.capitalPrimeTarget.bcbs_oonoopindamount_cp,
                null,
                null,
                null,
                goopValue
            );

        if (soopValue)
            setExactValue(
                config,
                cpLookup,
                fields.capitalPrimeTarget.bcbs_oonoopindamount_cp,
                null,
                null,
                null,
                soopValue
            );
    }
    // 13) OON Out of Pocket Family Amount
    // Explaination: Pharmacy Only copies the current Capital Prime OON family amount when its
    // numeric value is truthy. Combined Pharmacy and Medical writes the medical global family
    // amount for Out of Network, then the standard amount if present, so it overwrites global.
    // ---
    // IF capitalprime.bcbs_pboopaccumulationintegration_cp  != Pharmacy Only, (if (med.bcbs_oopglobalperfamilytier1 != null) capitalprime.bcbs_oonoopfamamount_cp = med.med.bcbs_oopglobalperfamilytier1 else capitalprime.bcbs_oonoopfamamount_cp = med.bcbs_aso_ded_family_mon_tier) ELSE  IF capitalprime.bcbs_pboopaccumulationintegration_cp = Pharmacy Only,  capitalprime.bcbs_oonoopfamamount_cp)
    // ---------------------------------------------------------------
    if (bcbs_pboopaccumulationintegration_cp === "Pharmacy Only") {
        const value = getExactValue<INumberValue>(
            cpLookup,
            fields.capitalPrime.bcbs_oonoopfamamount_cp,
            null,
            null,
            null
        );

        if (value?.value) {
            setExactValue(
                config,
                cpLookup,
                fields.capitalPrimeTarget.bcbs_oonoopfamamount_cp,
                null,
                null,
                null,
                value
            );
        }
    }
    else if (bcbs_pboopaccumulationintegration_cp === "Combined Pharmacy and Medical") {
        const goopValue = getExactValue<INumberValue>(
            mLookup,
            fields.medical.bcbs_oopglobalperfamilytier1,
            medicalTiers,
            'Out of Network',
            null
        );

        const soopValue = getExactValue<INumberValue>(
            mLookup,
            fields.medical.bcbs_aso_ded_family_mon_tier,
            medicalTiers,
            'Out of Network',
            null
        );

        if (goopValue)
            setExactValue(
                config,
                cpLookup,
                fields.capitalPrimeTarget.bcbs_oonoopfamamount_cp,
                null,
                null,
                null,
                goopValue
            );

        if (soopValue)
            setExactValue(
                config,
                cpLookup,
                fields.capitalPrimeTarget.bcbs_oonoopfamamount_cp,
                null,
                null,
                null,
                soopValue
            );
    }
    // 14) Out of Pocket Accumulator Type
    // Explaination: When OOP is Yes, Combined Pharmacy and Medical maps recognized medical OOP
    // types to Embedded or Aggregate; Pharmacy Only copies the current Capital Prime OOP
    // accumulator type. Other integration values do not write a value.
    // ---
    // IF capitalprime.bcbs_oopintegrationaccum_cp != Pharmacy Only, if (medical.bcbs_outofpockettype.ToLower() == ""individual coinsurance (indicator 20)"" ||
    //     oopType.ToLower() == ""individual and family combination coinsurance (indicator 24)"")
    //     return ""Embedded"";
    // else if (oopType.ToLower() == ""family coinsurance (indicator 22)"" ||
    //     oopType.ToLower() == ""individual and family coinsurance based on member coverage status (indicator 27)"")
    //     return ""Aggregate""; IF capitalprime.bcbs_oopintegrationaccum_cp = Pharmacy Only, capitalprime.bcbs_oopaccumulatortype_cp
    // ---------------------------------------------------------------
    if ((bcbs_oop_cp ?? "") === "Yes") {
        if (bcbs_oopintegrationaccum_cp === "Combined Pharmacy and Medical") {

            // Family Coinsurance (Indicator 22)
            // Individual and Family Coinsurance Based on Member Coverage Status (Indicator 27)
            // Individual and Family Combination Coinsurance (Indicator 24)
            // Individual Coinsurance (Indicator 20)
            const value = getExactValue<IEntityReferenceValue>(
                mLookup,
                fields.medical.bcbs_outofpockettype,
                medicalTiers,
                null,
                null
            );

            if (value) {
                let newValue: string | null = null;

                if (
                    value.name.includes("Indicator 20") ||
                    value.name.includes("Indicator 24")
                ) {
                    newValue = "Embedded";
                } else if (
                    value.name.includes("Indicator 22") ||
                    value.name.includes("Indicator 27")
                ) {
                    newValue = "Aggregated / Non-Embedded";
                }

                if (newValue)
                    setExactValue(
                        config,
                        cpLookup,
                        fields.capitalPrimeTarget.bcbs_oopaccumulatortype_cp,
                        null,
                        null,
                        null,
                        newValue
                    );
            }
        }
        else if (bcbs_oopintegrationaccum_cp === "Pharmacy Only") {
            let newValue_bcbs_oopaccumulatortype_cp = bcbs_oopaccumulatortype_cp;

            if (newValue_bcbs_oopaccumulatortype_cp) {
                setExactValue(
                    config,
                    cpLookup,
                    fields.capitalPrimeTarget.bcbs_oopaccumulatortype_cp,
                    null,
                    null,
                    null,
                    newValue_bcbs_oopaccumulatortype_cp
                );
            }
        }


    }
    // 15) Out of Pocket Accumulation Period
    // Explaination: When Capital Prime OOP is Yes, map the medical benefit period: Calendar Year
    // to Calendar and Contract Year to Ben Reset Date.
    // ---
    // IF (capitalprime.bcbs_oop_cp = "yes") IF (med.bcbs_benefitperiodrunsona = 'Calendar Year')  FIELD TBD = 'Calendar Year' else if (med.bcbs_benefitperiodrunsona = 'Contract Year') FIELD TBD = 'Ben Reset Date'
    // ---------------------------------------------------------------
    if ((bcbs_oop_cp ?? "") === "Yes") {

        const medical_bcbs_benefitperiodrunsona = getExactValue<IEntityReferenceValue>(
            mLookup,
            fields.medical.bcbs_benefitperiodrunsona,
            null,
            null,
            null
        );

        if (medical_bcbs_benefitperiodrunsona?.name === "Calendar Year") {
            setExactValue(
                config,
                cpLookup,
                fields.capitalPrimeTarget.bcbs_oopaccumulationperiod_cp,
                null,
                null,
                null,
                "Calendar"
            );
        }

        if (medical_bcbs_benefitperiodrunsona?.name === "Contract Year") {
            setExactValue(
                config,
                cpLookup,
                fields.capitalPrimeTarget.bcbs_oopaccumulationperiod_cp,
                null,
                null,
                null,
                "Ben Reset Date"
            );
        }
    }

    // 16) Out of Pocket Accumulation Period Start Date (mm/dd/yyyy)
    // Explaination: When Capital Prime OOP is Yes, copy the medical initial benefit period start
    // date value to the Capital Prime OOP start date; write null if missing.
    // ---
    // if (capitalprime.bcbs_oop_cp) = "yes": use medical.bcbs_initialbenefitperiodrunsfrom
    // ---------------------------------------------------------------
    if ((bcbs_oop_cp ?? "") === "Yes") {

        const medical_bcbs_initialbenefitperiodrunsfrom = getExactValue<IDateValue>(
            mLookup,
            fields.medical.bcbs_initialbenefitperiodrunsfrom,
            null,
            null,
            null
        );

        setExactValue(
            config,
            cpLookup,
            fields.capitalPrimeTarget.bcbs_oopstartdate_cp,
            null,
            null,
            null,
            medical_bcbs_initialbenefitperiodrunsfrom?.value ?? null
        );
    }
    // 17) Out of Pocket Accumulation Period End Date (mm/dd/yyyy)
    // Explaination: When Capital Prime OOP is Yes, copy the previously-read medical initial
    // benefit period through date value to the Capital Prime OOP end date; write null if missing.
    // ---
    // if (capitalprime.bcbs_oop_cp) = "yes": use medicalbcbs_initialbenefitperiodrunsthrough
    // ---------------------------------------------------------------
    if ((bcbs_oop_cp ?? "") === "Yes") {

        setExactValue(
            config,
            cpLookup,
            fields.capitalPrimeTarget.bcbs_oopenddate_cp,
            null,
            null,
            null,
            medical_bcbs_initialbenefitperiodrunsthrough?.value ?? null
        );
    }
    // 18) Out of Pocket - Individual Amount
    // Explaination: Pharmacy Only copies the current Capital Prime individual amount when its
    // numeric value is truthy. Combined Pharmacy and Medical writes the medical global
    // individual OOP amount for In Network, then the standard amount if present, overwriting it.
    // ---
    // IF capitalprime.bcbs_oopintegrationaccum_cp != Pharmacy Only, (check if bcbs_oopglobalpermembermaxtier1 has a value. If it does use, bcbs_oopglobalpermembermaxtier1. If not, pull from bcbs_aso_ded_mbr_mon_tier) ELSE IF capitalprime.bcbs_oopintegrationaccum_cp = Pharmacy Only, capitalprime.bcbs_oopindamount_cp
    // ---------------------------------------------------------------
    if (bcbs_oopintegrationaccum_cp === "Pharmacy Only") {
        const value = getExactValue<INumberValue>(
            cpLookup,
            fields.capitalPrime.bcbs_oopindamount_cp,
            null,
            null,
            null
        );

        if (value?.value) {
            setExactValue(
                config,
                cpLookup,
                fields.capitalPrimeTarget.bcbs_oopindamount_cp,
                null,
                null,
                null,
                value
            );
        }
    }
    else if (bcbs_oopintegrationaccum_cp === "Combined Pharmacy and Medical") {
        const goopValue = getExactValue<INumberValue>(
            mLookup,
            fields.medical.bcbs_oopglobalpermembermaxtier1,
            medicalTiers,
            'In Network',
            null
        );

        const soopValue = getExactValue<INumberValue>(
            mLookup,
            fields.medical.bcbs_aso_ded_mbr_mon_tier,
            medicalTiers,
            'In Network',
            null
        );

        if (goopValue)
            setExactValue(
                config,
                cpLookup,
                fields.capitalPrimeTarget.bcbs_oopindamount_cp,
                null,
                null,
                null,
                goopValue
            );

        if (soopValue)
            setExactValue(
                config,
                cpLookup,
                fields.capitalPrimeTarget.bcbs_oopindamount_cp,
                null,
                null,
                null,
                soopValue
            );
    }
    // 19) Out of Pocket - Family Amount
    // Explaination: Pharmacy Only copies the current Capital Prime family amount when its numeric
    // value is truthy. Combined Pharmacy and Medical writes the medical global family OOP amount
    // for In Network, then the standard amount if present, overwriting it.
    // ---
    // IF capitalprime.bcbs_oopintegrationaccum_cp  != Pharmacy Only, (if (med.bcbs_oopglobalperfamilytier1 != null) prime.bcbs_oopamount_family = med.med.bcbs_oopglobalperfamilytier1 else prime.bcbs_oopamount_family = med.bcbs_aso_ded_family_mon_tier) ELSE  IF capitalprime.bcbs_oopintegrationaccum_cp = Pharmacy Only,  capitalprime.bcbs_oopfamilyamount_cp)
    // ---------------------------------------------------------------
    if (bcbs_oopintegrationaccum_cp === "Pharmacy Only") {
        const value = getExactValue<INumberValue>(
            cpLookup,
            fields.capitalPrime.bcbs_oopfamilyamount_cp,
            null,
            null,
            null
        );

        if (value?.value) {
            setExactValue(
                config,
                cpLookup,
                fields.capitalPrimeTarget.bcbs_oopfamilyamount_cp,
                null,
                null,
                null,
                value
            );
        }
    }
    else if (bcbs_oopintegrationaccum_cp === "Combined Pharmacy and Medical") {
        const goopValue = getExactValue<INumberValue>(
            mLookup,
            fields.medical.bcbs_oopglobalperfamilytier1,
            medicalTiers,
            'In Network',
            null
        );

        const soopValue = getExactValue<INumberValue>(
            mLookup,
            fields.medical.bcbs_aso_ded_family_mon_tier,
            medicalTiers,
            'In Network',
            null
        );

        if (goopValue)
            setExactValue(
                config,
                cpLookup,
                fields.capitalPrimeTarget.bcbs_oopfamilyamount_cp,
                null,
                null,
                null,
                goopValue
            );

        if (soopValue)
            setExactValue(
                config,
                cpLookup,
                fields.capitalPrimeTarget.bcbs_oopfamilyamount_cp,
                null,
                null,
                null,
                soopValue
            );
    }
    // 20) Onsite Deductible Per Family
    // Explaination: Medical or Medical Tier 1 copies the medical family deductible for Tier 1
    // when a value object exists. Pharmacy copies the current Capital Prime onsite family amount
    // only when its numeric value is truthy; other values do nothing.
    // ---
    // if capitalprime.bcbs_diffonsitededaccum_cp = "Medical" OR "Medical Tier 1": use medical.bcbs_fi_ppo_tfamaggfamouttiernetwork, else (pharmacy) capitalprime.bcbs_custompharmacyded_family_cp
    // ---------------------------------------------------------------
    if (["Medical", "Medical Tier 1"].includes(bcbs_diffonsitededaccum_cp ?? "")) {

        const value = getExactValue<INumberValue>(
            mLookup,
            fields.medical.bcbs_fi_ppo_tfamaggfamouttiernetwork,
            medicalTiers,
            'Tier 1',
            null
        );

        if (value)
            setExactValue(
                config,
                cpLookup,
                fields.capitalPrimeTarget.bcbs_custompharmacyded_family_cp,
                null,
                null,
                null,
                value
            );
    }
    else if (["Pharmacy"].includes(bcbs_diffonsitededaccum_cp ?? "")) {
        const value = getExactValue<INumberValue>(
            cpLookup,
            fields.capitalPrime.bcbs_custompharmacyded_family_cp,
            null,
            null,
            null
        );

        if (value?.value) {
            setExactValue(
                config,
                cpLookup,
                fields.capitalPrimeTarget.bcbs_custompharmacyded_family_cp,
                null,
                null,
                null,
                value
            );
        }

    }
    // 21) Onsite Deductible Per Member
    // Explaination: Medical or Medical Tier 1 copies the medical individual deductible for Tier 1
    // when a value object exists. Pharmacy copies the current Capital Prime onsite individual
    // amount only when its numeric value is truthy; other values do nothing.
    // ---
    // if capitalprime.bcbs_diffonsitededaccum_cp = Medical OR Medical Tier 1: use medical.bcbs_fi_ppo_tfamaggsingletierofnetwork, else (pharmacy) capitalprime.bcbs_custompharmacyded_member_cp
    // ---------------------------------------------------------------
    if (["Medical", "Medical Tier 1"].includes(bcbs_diffonsitededaccum_cp ?? "")) {

        const value = getExactValue<INumberValue>(
            mLookup,
            fields.medical.bcbs_fi_ppo_tfamaggsingletierofnetwork,
            medicalTiers,
            'Tier 1',
            null
        );

        if (value)
            setExactValue(
                config,
                cpLookup,
                fields.capitalPrimeTarget.bcbs_custompharmacyded_member_cp,
                null,
                null,
                null,
                value
            );
    }
    else if (["Pharmacy"].includes(bcbs_diffonsitededaccum_cp ?? "")) {
        const value = getExactValue<INumberValue>(
            cpLookup,
            fields.capitalPrime.bcbs_custompharmacyded_member_cp,
            null,
            null,
            null
        );

        if (value?.value) {
            setExactValue(
                config,
                cpLookup,
                fields.capitalPrimeTarget.bcbs_custompharmacyded_member_cp,
                null,
                null,
                null,
                value
            );
        }

    }
    // 22) Onsite Pharmacy OOP Per Family
    // Explaination: Pharmacy Only copies the current Capital Prime onsite family amount when its
    // numeric value is truthy. Medical or Medical Tier 1 reads the medical global and standard
    // individual OOP fields for Tier 1; standard overwrites global. Both write to the family target.
    // ---
    // if capitalprime.bcbs_diffonsiteoopaccum_cp = Medical OR Medical Tier 1:
    //  if medical.bcbs_oopglobalperfamilytier1 has a value:
    //      use bcbs_oopglobalperfamilytier1.
    //  else
    //      use medical.bcbs_aso_ded_family_mon_tier ELSE (pharmacy) capitalprime.bcbs_custompharmacyoop_family_cp"
    // ---------------------------------------------------------------
    if (bcbs_diffonsiteoopaccum_cp === "Pharmacy Only") {
        const value = getExactValue<INumberValue>(
            cpLookup,
            fields.capitalPrime.bcbs_custompharmacyoop_family_cp,
            null,
            null,
            null
        );

        if (value?.value) {
            setExactValue(
                config,
                cpLookup,
                fields.capitalPrimeTarget.bcbs_custompharmacyoop_family_cp,
                null,
                null,
                null,
                value
            );
        }
    }
    else if (["Medical", "Medical Tier 1"].includes(bcbs_diffonsiteoopaccum_cp ?? "")) {
        const goopValue = getExactValue<INumberValue>(
            mLookup,
            fields.medical.bcbs_oopglobalpermembermaxtier1,
            medicalTiers,
            'Tier 1',
            null
        );

        const soopValue = getExactValue<INumberValue>(
            mLookup,
            fields.medical.bcbs_aso_ded_mbr_mon_tier,
            medicalTiers,
            'Tier 1',
            null
        );

        if (goopValue)
            setExactValue(
                config,
                cpLookup,
                fields.capitalPrimeTarget.bcbs_custompharmacyoop_family_cp,
                null,
                null,
                null,
                goopValue
            );

        if (soopValue)
            setExactValue(
                config,
                cpLookup,
                fields.capitalPrimeTarget.bcbs_custompharmacyoop_family_cp,
                null,
                null,
                null,
                soopValue
            );
    }
    // Onsite Pharmacy OOP Per Member
    // Explaination: Pharmacy Only copies the current Capital Prime onsite individual amount when
    // its numeric value is truthy. Medical or Medical Tier 1 writes the medical global then
    // standard individual OOP values for Tier 1, so standard overwrites global when both exist.
    // ---
    // if capitalprime.bcbs_diffonsiteoopaccum_cp = Medical OR Medical Tier 1:
    //  if medical.bcbs_oopglobalpermembermaxtier1 has a value: use medical.bcbs_oopglobalpermembermaxtier1
    //  else use medical.bcbs_aso_ded_mbr_mon_tier ELSE (pharmacy) capitalprime.bcbs_custompharmacyoop_member_cp"
    // ---------------------------------------------------------------
    if (bcbs_diffonsiteoopaccum_cp === "Pharmacy Only") {
        const value = getExactValue<INumberValue>(
            cpLookup,
            fields.capitalPrime.bcbs_custompharmacyoop_member_cp,
            null,
            null,
            null
        );

        if (value?.value) {
            setExactValue(
                config,
                cpLookup,
                fields.capitalPrimeTarget.bcbs_custompharmacyoop_member_cp,
                null,
                null,
                null,
                value
            );
        }
    }
    else if (["Medical", "Medical Tier 1"].includes(bcbs_diffonsiteoopaccum_cp ?? "")) {
        const goopValue = getExactValue<INumberValue>(
            mLookup,
            fields.medical.bcbs_oopglobalpermembermaxtier1,
            medicalTiers,
            'Tier 1',
            null
        );

        const soopValue = getExactValue<INumberValue>(
            mLookup,
            fields.medical.bcbs_aso_ded_mbr_mon_tier,
            medicalTiers,
            'Tier 1',
            null
        );

        if (goopValue)
            setExactValue(
                config,
                cpLookup,
                fields.capitalPrimeTarget.bcbs_custompharmacyoop_member_cp,
                null,
                null,
                null,
                goopValue
            );

        if (soopValue)
            setExactValue(
                config,
                cpLookup,
                fields.capitalPrimeTarget.bcbs_custompharmacyoop_member_cp,
                null,
                null,
                null,
                soopValue
            );
    }
    // 24) Onsite Deductible Type
    // Explaination: Medical or Medical Tier 1 maps recognized medical deductible types to
    // Embedded or Aggregated / Non-Embedded. Pharmacy copies the current Capital Prime onsite
    // deductible type; other accumulation values do nothing.
    // ---
    // if capitalprime.bcbs_diffonsitededaccum_cp = ""Medical"" or ""Medical Tier 1""
    // if medical.bcbs_medicaldeductibletype is ""Individual (Indicator 21)"" or ""True Family Aggregate Deductible (Indicator 22 Embedded)"" or ""Standard Deductible (Indicator 23)""
    //     use ""Embedded""
    // else if medical.bcbs_medicaldeductibletype ""Family Aggregate Deductible (Indicator 27)""
    //     use ""Aggregate"" ELSE (Pharmacy) capitalprime.bcbs_onsitedeductibletype_cp
    // ---------------------------------------------------------------

    let newValue_bcbs_onsitedeductibletype_cp: string | null = null;


    if (["Medical", "Medical Tier 1"].includes(bcbs_diffonsitededaccum_cp ?? "")) {

        let newValue_bcbs_oondedaccumtype_cp: string | null = null;
        const value = getExactValue<IEntityReferenceValue>(
            mLookup,
            fields.medical.bcbs_medicaldeductibletype,
            medicalTiers,
            null,
            null
        );
        if (value) {
            if (value.name.includes("Indicator 21") ||
                value.name.includes("Indicator 22") ||
                value.name.includes("Indicator 23")
            ) {
                newValue_bcbs_onsitedeductibletype_cp = "Embedded";
            } else if (value.name.includes("Indicator 27")) {
                newValue_bcbs_onsitedeductibletype_cp = "Aggregated / Non-Embedded";
            }

            if (newValue_bcbs_onsitedeductibletype_cp)
                setExactValue(
                    config,
                    cpLookup,
                    fields.capitalPrimeTarget.bcbs_onsitedeductibletype_cp,
                    null,
                    null,
                    null,
                    newValue_bcbs_onsitedeductibletype_cp
                );
        }

    }
    else if (["Pharmacy"].includes(bcbs_diffonsitededaccum_cp ?? "")) {
        newValue_bcbs_onsitedeductibletype_cp = bcbs_onsitedeductibletype_cp;

        if (newValue_bcbs_onsitedeductibletype_cp) {
            setExactValue(
                config,
                cpLookup,
                fields.capitalPrimeTarget.bcbs_onsitedeductibletype_cp,
                null,
                null,
                null,
                newValue_bcbs_onsitedeductibletype_cp
            );
        }
    }


    // 25) Onsite OOP Type
    // Explaination: Medical or Medical Tier 1 maps recognized medical OOP types to Embedded or
    // Aggregate. Pharmacy Only copies the current Capital Prime onsite OOP type; the Pharmacy
    // value does not enter that branch.
    // ---
    //  if capitalprime.bcbs_diffonsiteoopaccum_cp = Medical OR Medical Tier 1: 
    //  if (medical.bcbs_outofpockettype == ""individual coinsurance (indicator 20)"" or ""individual and family combination coinsurance (indicator 24)""
    //    use ""Embedded""
    //  else if (medical.bcbs_outofpockettype == ""family coinsurance (indicator 22)"" || ""individual and family coinsurance based on member coverage status (indicator 27)"")
    //    use ""Aggregate"" ELSE (Pharmacy) capitalprime.bcbs_onsiteooptype_cp
    // ---------------------------------------------------------------
    if (["Medical", "Medical Tier 1"].includes(bcbs_diffonsiteoopaccum_cp ?? "")) {

        // Family Coinsurance (Indicator 22)
        // Individual and Family Coinsurance Based on Member Coverage Status (Indicator 27)
        // Individual and Family Combination Coinsurance (Indicator 24)
        // Individual Coinsurance (Indicator 20)
        const value = getExactValue<IEntityReferenceValue>(
            mLookup,
            fields.medical.bcbs_outofpockettype,
            medicalTiers,
            null,
            null
        );

        if (value) {
            let newValue: string | null = null;

            if (
                value.name.includes("Indicator 20") ||
                value.name.includes("Indicator 24")
            ) {
                newValue = "Embedded";
            } else if (
                value.name.includes("Indicator 22") ||
                value.name.includes("Indicator 27")
            ) {
                newValue = "Aggregate";
            }

            if (newValue)
                setExactValue(
                    config,
                    cpLookup,
                    fields.capitalPrimeTarget.bcbs_onsiteooptype_cp,
                    null,
                    null,
                    null,
                    newValue
                );
        }
    }
    else if (bcbs_diffonsiteoopaccum_cp === "Pharmacy Only") {
        let newValue_bcbs_onsiteooptype_cp = bcbs_onsiteooptype_cp;

        if (newValue_bcbs_onsiteooptype_cp) {
            setExactValue(
                config,
                cpLookup,
                fields.capitalPrimeTarget.bcbs_onsiteooptype_cp,
                null,
                null,
                null,
                newValue_bcbs_onsiteooptype_cp
            );
        }
    }
    // 26) Onsite Does Deductible Apply to OOP
    // Explaination: Medical or Medical Tier 1 copies the medical boolean only when true.
    // Pharmacy copies the current Capital Prime boolean only when true; false values are not written.
    // ---
    // bcbs_onsitedeductiblefeedoop_cp
    // if capitalprime.bcbs_diffonsitededaccum_cp = Medical OR Medical Tier 1: use medical.bcbs_aso_ded_oop_benefit_yr_ded
    // ---------------------------------------------------------------
    if (["Medical", "Medical Tier 1"].includes(bcbs_diffonsitededaccum_cp ?? "")) {

        const value = getExactValue<IBooleanValue>(
            mLookup,
            fields.medical.bcbs_aso_ded_oop_benefit_yr_ded,
            null,
            null,
            null
        );

        if (value?.value) {
            setExactValue(
                config,
                cpLookup,
                fields.capitalPrimeTarget.bcbs_onsitedeductiblefeedoop_cp,
                null,
                null,
                null,
                value
            );
        }

    }
    else if (["Pharmacy"].includes(bcbs_diffonsitededaccum_cp ?? "")) {
        const value = getExactValue<IBooleanValue>(
            cpLookup,
            fields.capitalPrime.bcbs_onsitedeductiblefeedoop_cp,
            null,
            null,
            null
        );

        if (value?.value) {
            setExactValue(
                config,
                cpLookup,
                fields.capitalPrimeTarget.bcbs_onsitedeductiblefeedoop_cp,
                null,
                null,
                null,
                value
            );
        }
    }

}

export const SyncPharmacyExtractList = (
    json: IGroupConfigurationData,
    config: IGroupConfigurationConfig,
    context: IPharmacyContextProps,
) => {
    const benefitLookup = ArrayToLookup(json.benefits);

    const pharmacyListLookup = ArrayToLookup(json.pharmacyORE ?? []);

    const newPharmacyList: IPharmacyORE[] = [];

    json.plans.forEach(plan => {

        if (plan.deactivated)
            return;

        if (plan.billingOnlyPlan)
            return;

        let bcbsrxBenefit: IBenefit | null = null;

        let primeBenefit: IBenefit | null = null;

        let capitalPrimeBenefit: IBenefit | null = null;

        let floridaPrimeBenefit: IBenefit | null = null;

        plan.benefitRefs.forEach(eachBenefitRef => {
            const benefit = benefitLookup[eachBenefitRef.id];

            if (!benefit)
                throw new Error(`Benefit not found for id: ${eachBenefitRef.id}`);

            const isBCBSRx = benefit?.bcbs_config_categoryid === config.cache.map_bcbs_config_category_named['Pharmacy']?.bcbs_config_categoryid;

            const isFloridaPrime = benefit?.bcbs_config_categoryid === config.cache.map_bcbs_config_category_named['Florida Prime']?.bcbs_config_categoryid

            const isCapitalPrime = benefit?.bcbs_config_categoryid === config.cache.map_bcbs_config_category_named['Capital Prime']?.bcbs_config_categoryid;

            if (isBCBSRx)
                bcbsrxBenefit = benefit;

            if (isFloridaPrime)
                floridaPrimeBenefit = benefit;

            if (isCapitalPrime)
                capitalPrimeBenefit = benefit;

            if (isFloridaPrime || isCapitalPrime)
                primeBenefit = benefit;
        });

        if ((floridaPrimeBenefit && context.isFloridaPrime) || (capitalPrimeBenefit && context.isCapitalPrime)) {

            // Only create a pharmacy extract entry if there is a prime benefit associated with the plan
            const pharmacyExtract = pharmacyListLookup[plan.id!] ??
            {
                id: plan.id,
                releaseStatus: "In Progress",
                pharmacyPlanDesign: "",
                newPharmacyPlanDesign: "",
                newClientNumber: ""
            };

            if (pharmacyExtract)
                newPharmacyList.push(pharmacyExtract);
        }

    });

    return newPharmacyList;
}
